var _style, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnderMaintenance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-under-construction",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-under-construction:not(.animated) .animable {opacity: 0;}svg#freepik_stories-under-construction.animated #freepik--Crane--inject-139 {animation: 2.7s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideRight,3s Infinite  linear wind;animation-delay: 0s,2.7s;}            @keyframes slideRight {                0% {                    opacity: 0;                    transform: translateX(30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes wind {                0% {                    transform: rotate( 0deg );                }                25% {                    transform: rotate( 1deg );                }                75% {                    transform: rotate( -1deg );                }            }        .animator-hidden { display: none; }")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-139",
    className: "animable animator-hidden",
    style: {
      transformOrigin: "369.647px 220.099px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.69,139.25s-11.64,4.41,1.11,29.2S99.38,205.5,99.38,205.5s2.26,5.76-2.59,6.67-15.54-.76-17.68,5.19c-2.22,6.17,2.27,12,11.36,17s28.59,16.89,30.35,18,3.46,3.73.26,4.88S93.85,261,95.76,272.31s29.55,21.28,32.55,22.42,3.72,2.42,3.48,4.06-8.4,1.76-15.2,2.78-14.51,3.38-12.86,9.83,18,19.93,57.76,23.69l18.51.53L190,320c19.41-34.85,17.58-56,13.2-61s-10.69,0-15.38,5-9.41,11.69-10.9,11-2.13-2.05-1.37-5.17,8.21-31.54,0-39.53-24,10.34-26.76,12.33-4-1-3.88-3,1.41-24.83,2.39-35.19-1.26-17.35-7.6-19c-6.11-1.6-10.79,8.15-14.29,11.63s-7-1.65-7-1.65-5.11-14.21-18.31-38.77-23.66-17.23-23.66-17.23",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "138.949px 237.008px"
    },
    id: "elkbjwo0eairl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,340c-9.62-18.08-26.19-50.48-40.55-78.23S113,208.91,103.49,190.8c-4.76-9-8.63-16.36-11.31-21.45-1.32-2.52-2.35-4.48-3.07-5.83-.34-.66-.6-1.16-.78-1.53a5.59,5.59,0,0,1-.25-.52s.11.16.3.5l.83,1.49,3.17,5.79c2.74,5,6.66,12.32,11.47,21.36,9.63,18.07,22.71,43.14,37.08,70.88s30.87,60.18,40.4,78.3",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "134.705px 250.735px"
    },
    id: "el71dz7350t6d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,220.29a7.17,7.17,0,0,1,1.3.36c.82.26,2,.67,3.44,1.19,2.89,1.06,6.85,2.61,11.19,4.4L121,230.87l3.36,1.38a6.3,6.3,0,0,1,1.22.55,5.46,5.46,0,0,1-1.29-.34c-.82-.26-2-.68-3.44-1.21-2.88-1.08-6.82-2.69-11.16-4.48l-11.12-4.55-3.37-1.36A5.85,5.85,0,0,1,94,220.29Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "109.79px 226.545px"
    },
    id: "elzr9upt91s1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.83,231.62c-.14-.06,2.7-8.36,6.35-18.55s6.74-18.4,6.89-18.35-2.69,8.36-6.35,18.55S127,231.67,126.83,231.62Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "133.45px 213.17px"
    },
    id: "elqktqwporcap",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,275.22a6.06,6.06,0,0,1,.75-1.15l2.19-3c1.83-2.54,4.36-6.06,7-10.05s4.93-7.67,6.56-10.35l1.93-3.18a7.6,7.6,0,0,1,.76-1.14,5.18,5.18,0,0,1-.57,1.25c-.4.78-1,1.9-1.77,3.27-1.54,2.74-3.77,6.47-6.43,10.47s-5.23,7.49-7.16,10c-1,1.23-1.76,2.23-2.33,2.9A6.31,6.31,0,0,1,147,275.22Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "156.595px 260.785px"
    },
    id: "el3dvy1cpw4y8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,271.52a4.88,4.88,0,0,1,1.26,0l3.43.26c2.89.25,6.88.63,11.28,1.08s8.39.89,11.27,1.24l3.41.44a5.44,5.44,0,0,1,1.24.24,5.54,5.54,0,0,1-1.26,0l-3.43-.26c-2.89-.25-6.88-.63-11.29-1.08s-8.38-.89-11.26-1.24l-3.41-.44A5.27,5.27,0,0,1,115,271.52Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "130.945px 273.148px"
    },
    id: "elasys58lcyj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.89,312.26a9,9,0,0,1,1.61,0l4.4.32c3.7.29,8.82.74,14.47,1.26s10.76,1,14.46,1.43l4.38.5a8.88,8.88,0,0,1,1.6.26,8.37,8.37,0,0,1-1.62,0l-4.4-.32c-3.7-.29-8.82-.74-14.47-1.27s-10.76-1-14.46-1.43l-4.38-.49A8.81,8.81,0,0,1,127.89,312.26Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "148.35px 314.147px"
    },
    id: "elhl1odhry1mi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.85,315.71a10.57,10.57,0,0,1,.91-1.48l2.63-3.91c2.22-3.31,5.27-7.89,8.49-13s6-9.88,8-13.32c1-1.65,1.76-3,2.38-4.08a10.3,10.3,0,0,1,.92-1.46,8.58,8.58,0,0,1-.73,1.57c-.5,1-1.25,2.42-2.21,4.17-1.92,3.49-4.66,8.27-7.9,13.43s-6.33,9.71-8.63,13c-1.16,1.62-2.11,2.92-2.78,3.81A9.94,9.94,0,0,1,167.85,315.71Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "179.515px 297.085px"
    },
    id: "elt3855qpvmug",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.71,373.82c-26.68-17.43-33.66-51.11-33.57-81.58,0-5.08-.71-10.42,1.56-14.95s7.83-7.76,12.44-5.76c3.83,1.66,5.61,6,7.84,9.56a29.64,29.64,0,0,0,12.27,11c3.28,1.58,7.32,2.48,10.46.62,4.3-2.55,4.63-8.62,4.44-13.68l-1-28.24c-.19-5.06-.37-10.21,1.06-15.06s4.75-9.41,9.52-10.9,10.79,1.09,12,6c.49,2,.14,4.2.34,6.29s1.26,4.38,3.27,4.91,4-1,5.47-2.5c5.06-5.26,8.39-11.94,11.5-18.58s6.11-13.43,10.66-19.14,11-10.33,18.2-11,15.07,3.59,17.12,10.63-1.88,14.43-6.22,20.34a113,113,0,0,1-22.79,23.11c-1.56,1.18-3.24,2.46-3.79,4.35-1,3.4,2.3,6.65,5.66,7.65,3.8,1.14,7.88.62,11.83,1s8.28,2,9.89,5.63c2.23,5.1-1.92,10.64-6.06,14.32a96.61,96.61,0,0,1-28.09,17.4c-3.67,1.47-7.55,2.79-10.46,5.49s-4.59,7.31-2.66,10.81,6.6,4.5,10.47,3.66,7.29-3.07,11-4.58c6.86-2.84,15.84-2.64,20.48,3.22,3.05,3.86,3.47,9.34,2.14,14.09s-4.2,8.89-7.27,12.72c-10.72,13.41-24.64,24.36-40.58,30.45s-30.81,8.06-47,2.71",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "558.942px 283.831px"
    },
    id: "elon67tt91sta",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531,354.49c4-15.5,9.8-32.12,16.46-49.3q2.52-6.44,5-12.71c1.65-4.16,3.28-8.29,5.12-12.24a225.71,225.71,0,0,1,11.89-22c4.12-6.83,8.28-13.16,12.21-19s7.73-11.3,11.39-16.09a179.68,179.68,0,0,1,18.92-21.29c2.43-2.33,4.36-4.07,5.69-5.24l1.52-1.32a4.2,4.2,0,0,1,.54-.42,4.23,4.23,0,0,1-.47.5l-1.46,1.38c-1.29,1.21-3.19,3-5.57,5.37a189.08,189.08,0,0,0-18.65,21.43c-3.61,4.8-7.36,10.22-11.27,16.12s-8,12.24-12.12,19.06a230.27,230.27,0,0,0-11.8,22c-1.82,3.92-3.43,8-5.08,12.19s-3.29,8.41-5,12.7c-6.65,17.17-12.46,33.74-16.49,49.18",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "575.37px 274.845px"
    },
    id: "elail9twqrhzb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.78,280.2a11.18,11.18,0,0,1-.56-2.14c-.31-1.39-.69-3.41-1.12-5.92-.87-5-1.84-12-2.87-19.64s-2.1-14.6-3.05-19.58c-.46-2.5-.86-4.51-1.15-5.9a9.16,9.16,0,0,1-.35-2.18,10.74,10.74,0,0,1,.7,2.1c.4,1.36.9,3.36,1.44,5.84,1.12,5,2.29,11.91,3.33,19.59s1.91,14.43,2.6,19.67q.5,3.56.83,6A9.47,9.47,0,0,1,557.78,280.2Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "553.231px 252.52px"
    },
    id: "el6gxb8duskz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.37,266a14.46,14.46,0,0,1-2.58.39c-1.66.2-4.07.48-7,.91-5.93.83-14.08,2.26-23,4.23s-16.92,4.13-22.66,5.85c-2.88.84-5.19,1.58-6.79,2.08a13.68,13.68,0,0,1-2.52.7,14.7,14.7,0,0,1,2.4-1.05c1.57-.61,3.85-1.45,6.71-2.37,5.71-1.88,13.71-4.13,22.66-6.13a231,231,0,0,1,23.13-4c3-.35,5.4-.53,7.08-.62A13.73,13.73,0,0,1,622.37,266Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "590.095px 273.047px"
    },
    id: "elricnr7p5ufi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.73,353.27a3,3,0,0,1-.47-.78l-1.18-2.31c-1-2-2.42-5-4.1-8.65-3.37-7.34-7.7-17.63-12.32-29s-8.86-21.75-12.07-29.15l-3.82-8.76-1-2.39a3.64,3.64,0,0,1-.3-.86,3,3,0,0,1,.47.78c.32.62.71,1.39,1.19,2.31,1,2,2.41,5,4.09,8.64,3.37,7.35,7.7,17.64,12.33,29.07s8.85,21.74,12.06,29.14L530.4,350l1,2.39A3.13,3.13,0,0,1,531.73,353.27Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "514.1px 312.32px"
    },
    id: "el16f2l0y4s8h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.19,322.76a3.52,3.52,0,0,1-.84.38l-2.48.92-9.15,3.28c-7.73,2.78-18.36,6.73-30.1,11.12s-22.41,8.25-30.2,10.86c-3.89,1.31-7,2.34-9.25,3l-2.54.75a3.52,3.52,0,0,1-.9.2,3.49,3.49,0,0,1,.85-.38l2.48-.92,9.15-3.28c7.72-2.77,18.35-6.73,30.09-11.11s22.42-8.25,30.2-10.86c3.89-1.31,7-2.34,9.25-3l2.54-.75A3.52,3.52,0,0,1,617.19,322.76Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "574.46px 338.015px"
    },
    id: "elblsb7k7e41t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.6,97.55c.8-5.86-7.46-10.68-13.68-11.18-3-.24-6,.22-8.84-.76-6.08-2.12-8.51-10-14.44-12.48-4.44-1.87-9.55-.2-13.85,2S92.24,80,87.44,80.28c-4.18.27-8.72-1.28-12.38.76-2.72,1.53-4.15,4.66-6.66,6.52s-5.66,2.19-8.71,2.36-6.2.19-9,1.47-5.07,4.2-4.49,7.2Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "98.8814px 85.4557px"
    },
    id: "elutrdvbptoka",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.83,151.22c.84-6.06-7.72-11-14.15-11.56-3.06-.25-6.25.22-9.15-.79-6.29-2.2-8.8-10.32-14.94-12.91-4.59-1.94-9.88-.22-14.33,2s-8.84,5.06-13.82,5.38c-4.32.28-9-1.33-12.8.79-2.82,1.57-4.29,4.82-6.89,6.73s-5.86,2.28-9,2.45-6.42.2-9.3,1.52-5.24,4.35-4.65,7.45Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "510.298px 138.698px"
    },
    id: "el5jq32v85g4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.15,177.83c.51-3.73-4.75-6.8-8.71-7.12-1.89-.15-3.85.14-5.64-.49-3.87-1.35-5.42-6.35-9.2-7.95-2.82-1.19-6.08-.13-8.82,1.25s-5.44,3.12-8.51,3.31c-2.66.17-5.55-.82-7.88.49-1.73,1-2.64,3-4.24,4.14A10.14,10.14,0,0,1,634.6,173a15.44,15.44,0,0,0-5.72.93c-1.77.81-3.24,2.68-2.87,4.59Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "659.568px 170.137px"
    },
    id: "ellnzo0iwiii",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.9,92.54c.94-6.79-8.65-12.38-15.85-13-3.43-.28-7,.25-10.26-.89-7-2.45-9.86-11.56-16.74-14.46C625.91,62.06,620,64,615,66.5s-9.91,5.67-15.48,6c-4.85.31-10.11-1.48-14.35.88-3.16,1.77-4.81,5.41-7.72,7.55s-6.57,2.55-10.1,2.74-7.2.23-10.41,1.7-5.88,4.88-5.22,8.36Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "612.792px 78.5036px"
    },
    id: "elmsguixlyop",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-139",
    className: "animable",
    style: {
      transformOrigin: "340.965px 255.166px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.69,117.48c2.75-1.18,5.69,1.33,7.19,3.92s2.71,5.72,5.45,6.92c2.13.93,4.58.4,6.91.49,7.15.28,12.69,6.45,15.9,12.85,2,4,3.46,8.59,2.13,12.84-1.17,3.74-4.32,6.52-7.6,8.66a37.69,37.69,0,0,1-22.33,6.34,28.84,28.84,0,0,1-20.6-10.06c-3.85-4.72-5.9-10.69-6.79-16.71s-.69-12.14-.49-18.22",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "288.535px 143.353px"
    },
    id: "elvfpv8mrpjtr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.63,149c-.05,0,0-.65-.12-1.78a13.7,13.7,0,0,0-1.33-4.62,14.93,14.93,0,0,0-4.51-5.44,18.84,18.84,0,0,0-8-3.37c-3.05-.55-6.09-.27-8.82-.85a14,14,0,0,1-6.45-3.34,22.07,22.07,0,0,1-3.26-3.66c-.33-.47-.58-.84-.74-1.11a2.45,2.45,0,0,1-.22-.41,16.1,16.1,0,0,1,1.12,1.4,25.27,25.27,0,0,0,3.34,3.5,13.71,13.71,0,0,0,6.31,3.15c2.63.54,5.66.25,8.81.81a18.8,18.8,0,0,1,8.18,3.5,15,15,0,0,1,4.56,5.66,13.24,13.24,0,0,1,1.2,4.76,9,9,0,0,1,0,1.33A1.62,1.62,0,0,1,310.63,149Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "293.952px 136.71px"
    },
    id: "elrnnz3seejt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.46,135.93l-10.53,39.42-21.38-23a55.66,55.66,0,0,0-33.2-9h0l-33.26-1.55-18.36,6.61a67.9,67.9,0,0,0-12.66,6.15l-35.78,24.69c-7.57,5.47-13.79,9.65-15.25,18-1.92,11,3.65,23.33,15.24,25.37l50.61.61,1.56,32L305,247.83l-2.13-48.29c16.24,12.51,23.87,17.38,36.09,15,4.07-.79,9.89-5.07,11.78-11.41,6.75-22.6,7.9-58.15,7.9-58.15ZM213.7,192.5l4.62-1.31.29,1.67Z",
    style: {
      fill: "#0C3450",
      transformOrigin: "258.154px 195.58px"
    },
    id: "elzcsh904pvjk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.53,222.64l.43,0,1.25,0,4.83,0,17.78-.05,58.87,0-.26.25c0-.58.06-1.2.09-1.82.37-7.95.73-15.64,1.06-22.79l.23.27c-17.91-1.67-33.26-4.25-44.21-5.64-5.48-.72-9.86-1.2-12.86-1.55l-3.44-.38-.89-.11-.3-.05h.31l.89.07,3.45.3c3,.29,7.39.73,12.88,1.41,11,1.3,26.32,3.81,44.21,5.45l.24,0v.24c-.33,7.14-.68,14.84-1,22.79,0,.62-.06,1.24-.09,1.81v.25h-.25l-58.87-.2L179,222.76l-4.83-.06-1.25,0A2.43,2.43,0,0,1,172.53,222.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "214.81px 206.93px"
    },
    id: "el92w74out8ab",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.55,188.45a3,3,0,0,1,.81-.4,17.71,17.71,0,0,1,2.34-.77,23.27,23.27,0,0,1,15.91,1.6,16.75,16.75,0,0,1,2.14,1.22,3.25,3.25,0,0,1,.72.55c-.06.08-1.13-.62-3-1.44a25.64,25.64,0,0,0-15.68-1.57C174.78,188.07,173.58,188.54,173.55,188.45Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "184.51px 188.605px"
    },
    id: "elrqzg55msqx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.56,179.26a9.86,9.86,0,0,1,2.18,1.16,40.54,40.54,0,0,1,4.79,3.52c1.74,1.51,3.34,3,4,4.43a3.93,3.93,0,0,1,.41,1.8,1.32,1.32,0,0,1-.15.66,5.17,5.17,0,0,0-.58-2.29,17.79,17.79,0,0,0-4-4.2c-1.75-1.5-3.43-2.74-4.66-3.61A14.45,14.45,0,0,1,184.56,179.26Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "190.25px 185.045px"
    },
    id: "elu4u706arzmi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219,193.05a20.23,20.23,0,0,1-.9-3.13c-.5-1.94-1.16-4.63-2-7.57s-1.66-5.58-2.35-7.46-1.15-3-1.08-3.06a2.9,2.9,0,0,1,.45.76c.26.5.59,1.24,1,2.17a67.4,67.4,0,0,1,2.5,7.45c.81,3,1.41,5.67,1.82,7.63A19.91,19.91,0,0,1,219,193.05Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "215.831px 182.44px"
    },
    id: "ellbdgsnn175n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.9,221.94c-.14,0-.71-12-1.28-26.83s-.91-26.86-.76-26.86.72,12,1.28,26.84S304.05,221.94,303.9,221.94Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "302.88px 195.095px"
    },
    id: "elttsux8o26y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elmvzzu8ohsp"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "305.853px 188.9px"
    },
    className: "animable",
    id: "el582s569wwgd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.29,173.76c.83,5.16,3,10,4.79,14.91s3,10.26,1.94,15.37l-6-4.81",
    id: "el54o909d8hs",
    className: "animable",
    style: {
      transformOrigin: "305.853px 188.9px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M333.15,196.53a3.23,3.23,0,0,1-.46-.75c-.27-.5-.61-1.24-1-2.17a47.78,47.78,0,0,1-3.69-15.3c-.07-1-.09-1.83-.08-2.39A3.41,3.41,0,0,1,328,175a28,28,0,0,1,.39,3.24A62.07,62.07,0,0,0,332,193.47C332.72,195.35,333.22,196.49,333.15,196.53Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "330.536px 185.765px"
    },
    id: "elp8k7ifg95e8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ela0q7g5xlppk"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "214.08 175.1 215.37 192.03 218.32 191.19 214.08 175.1",
    style: {
      opacity: 0.3,
      transformOrigin: "216.2px 183.565px"
    },
    className: "animable",
    id: "eld4h4zaejyiv"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M300.47,175a.86.86,0,0,1-.26-.11l-.75-.36a22.05,22.05,0,0,0-2.95-1.16,22.67,22.67,0,0,0-11.49-.58,24.17,24.17,0,0,0-7.4,3c-2.49,1.46-5,3.32-7.72,5.13a29.66,29.66,0,0,1-9.3,4.38,27.18,27.18,0,0,1-11,.45,30.62,30.62,0,0,1-5.43-1.48,27.89,27.89,0,0,1-4.87-2.49,26.26,26.26,0,0,1-4.1-3.33,37.44,37.44,0,0,1-3.29-3.82c-2-2.62-3.67-5.23-5.39-7.57a33.55,33.55,0,0,0-5.35-6,21.25,21.25,0,0,0-5.61-3.45,14.53,14.53,0,0,0-4.85-1.09,13,13,0,0,0-4.2.6l.26-.11.78-.27c.35-.11.8-.19,1.32-.3a12.57,12.57,0,0,1,1.85-.12,14,14,0,0,1,4.94,1,21.27,21.27,0,0,1,5.75,3.44,32.69,32.69,0,0,1,5.45,6c1.75,2.33,3.44,4.94,5.43,7.52a38.07,38.07,0,0,0,3.26,3.77,26.08,26.08,0,0,0,4,3.25,27.9,27.9,0,0,0,4.78,2.44,28.78,28.78,0,0,0,5.34,1.44,26.63,26.63,0,0,0,10.81-.43,29.3,29.3,0,0,0,9.17-4.29c2.73-1.78,5.23-3.63,7.77-5.1a24.36,24.36,0,0,1,7.54-3,22.41,22.41,0,0,1,11.63.75,20.44,20.44,0,0,1,2.93,1.25l.72.41Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "253.49px 171.215px"
    },
    id: "eljdahqyggi2c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,166.83a4.38,4.38,0,0,1,.11,1.23,17.29,17.29,0,0,1-.28,3.38,17.77,17.77,0,0,1-1.59,4.77,30.64,30.64,0,0,1-3.3,5.18,24.51,24.51,0,0,1-8.68,6.94,21.41,21.41,0,0,1-3.15,1.21,5.14,5.14,0,0,1-1.21.27c0-.1,1.68-.53,4.2-1.81a25.77,25.77,0,0,0,8.43-6.93,32,32,0,0,0,3.28-5.08,18.57,18.57,0,0,0,1.66-4.62A40.49,40.49,0,0,0,320,166.83Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "311.008px 178.32px"
    },
    id: "eluq6pyktl6y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.1,214.56s-.14-.05-.38-.21a9.4,9.4,0,0,1-1-.71,16.42,16.42,0,0,1-3.21-3.31A24.75,24.75,0,0,1,323,196a50.22,50.22,0,0,1,2.59-14.92c.57-1.86,1.08-3.34,1.44-4.36a11.77,11.77,0,0,1,.62-1.57,11.62,11.62,0,0,1-.42,1.63c-.33,1.13-.77,2.61-1.29,4.4A53.89,53.89,0,0,0,323.52,196a25.24,25.24,0,0,0,4.26,14.15A22.53,22.53,0,0,0,332.1,214.56Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "327.55px 194.855px"
    },
    id: "elqh69gv83bss",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.68,169.77a4.85,4.85,0,0,1-1,.53c-.64.3-1.57.71-2.75,1.15a25.12,25.12,0,0,1-9.69,1.64,16.3,16.3,0,0,1-9.22-3.3,11.35,11.35,0,0,1-2.1-2.13,3.59,3.59,0,0,1-.58-.93,20.47,20.47,0,0,0,2.91,2.77,16.79,16.79,0,0,0,9,3.07,27.1,27.1,0,0,0,9.55-1.47C354.22,170.32,355.64,169.69,355.68,169.77Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "343.01px 169.915px"
    },
    id: "elutnpd8jcsu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.89,191.85c-.09,0-.49-1.56-1.42-4a45.17,45.17,0,0,0-11.29-16.93c-1.91-1.8-3.21-2.79-3.16-2.86a4.54,4.54,0,0,1,1,.62,28.88,28.88,0,0,1,2.44,2,40.43,40.43,0,0,1,11.38,17.07,29.87,29.87,0,0,1,.88,3A4.75,4.75,0,0,1,206.89,191.85Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "198.954px 179.955px"
    },
    id: "el8tnp77n7ic8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.57,193.57a2,2,0,0,1-.26.53,11.52,11.52,0,0,1-.95,1.42,15.59,15.59,0,0,1-4.86,4,28.78,28.78,0,0,1-8.84,2.89c-3.45.59-7.3.83-11.25,1.47a33.22,33.22,0,0,0-5.66,1.39,23.3,23.3,0,0,0-4.85,2.39,24.76,24.76,0,0,0-6.6,6.31,25.37,25.37,0,0,0-2.92,5.47c-.54,1.37-.71,2.17-.77,2.15a2.27,2.27,0,0,1,.11-.58,12.16,12.16,0,0,1,.47-1.64,23.52,23.52,0,0,1,2.81-5.61,24.38,24.38,0,0,1,6.64-6.5,23.27,23.27,0,0,1,4.94-2.47,33.94,33.94,0,0,1,5.74-1.43c4-.64,7.84-.86,11.26-1.42a29.47,29.47,0,0,0,8.75-2.74,16.18,16.18,0,0,0,4.87-3.77C218.14,194.27,218.52,193.54,218.57,193.57Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "195.09px 207.58px"
    },
    id: "elcpgdtp6nel",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.92,196.32a4.11,4.11,0,0,1,.35,1,20.08,20.08,0,0,1,.59,2.78,26.59,26.59,0,0,1,.25,4.22,26.41,26.41,0,0,1-2.21,10.06,25.18,25.18,0,0,1-2,3.72,20.28,20.28,0,0,1-1.7,2.28c-.45.5-.7.77-.73.74s.89-1.18,2.12-3.21a30.53,30.53,0,0,0,1.87-3.72,31.29,31.29,0,0,0,1.53-4.84,30.6,30.6,0,0,0,.64-5.05,28.26,28.26,0,0,0-.14-4.15C240.23,197.77,239.82,196.34,239.92,196.32Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "237.792px 208.721px"
    },
    id: "elm8kb7bicmg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.24,211.48a28,28,0,0,0-6.72-1.92,28.84,28.84,0,0,0-7,.28,5.9,5.9,0,0,1,2-.62,16.48,16.48,0,0,1,9.92,1.18A5.86,5.86,0,0,1,302.24,211.48Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "295.38px 210.202px"
    },
    id: "elbuwb4cjog1b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.88 111.12 338.82 136.1 357.75 144.58 362.61 123.34 348.88 111.12",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "350.715px 127.85px"
    },
    id: "el7f8xfy6hqp9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.6,135.78l-17-21.1h0c-3.43-4.74-8.89-12.37-9.14-13-.35-1-.48-7.82-.32-9.55a54.54,54.54,0,0,0-.43-6.64l-14,5.31L326.72,80l-1.92.6s-5.07,8.77-3.5,13.76,8.2,7.25,9.84,8.26,7.87,3.69,14.9,14.3l1.13,1.64h0l2.85,4.12h0l13,18.7a4.73,4.73,0,1,0,7.59-5.63Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "346.336px 111.734px"
    },
    id: "elv007g0k9jaq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.21,87.91l-3.66-10.32,1.32-.43s6.46,4,7.85,8.66Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "338.135px 82.535px"
    },
    id: "eljmw0ra5oh9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.3,101.54l.16-.07.44-.2,1.65-.74,6-2.72-.15-.09a16,16,0,0,0,0,1.83,5.15,5.15,0,0,0,.44,2c.69,1.18,1.53,2.34,2.39,3.58,1.73,2.45,3.65,5.11,5.68,7.87a2.5,2.5,0,0,1,.58,1.16,1.95,1.95,0,0,1-2.32,2.2,1.91,1.91,0,0,1-1-.59c-.25-.31-.5-.68-.75-1l-1.47-2-5.07-6.84a6,6,0,0,0-1.25-1.22c-.44-.33-.87-.61-1.27-.88-.81-.52-1.53-.94-2.12-1.27s-1.06-.58-1.37-.75l-.37-.18-.13,0s0,0,.12.07l.35.21,1.34.79c.59.35,1.29.78,2.09,1.31.4.27.83.56,1.25.89a5.5,5.5,0,0,1,1.21,1.2l5,6.87,1.46,2c.25.34.48.67.76,1a2.26,2.26,0,0,0,1.18.67,2.22,2.22,0,0,0,2.65-2.5,2.81,2.81,0,0,0-.63-1.28c-2-2.76-4-5.41-5.7-7.86-.85-1.23-1.71-2.4-2.38-3.54a5,5,0,0,1-.43-1.85,13.76,13.76,0,0,1,0-1.81v-.17l-.15.07-6,2.86-1.6.78-.41.2Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "342.052px 107.159px"
    },
    id: "elqb5692dllto",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el3vsc5xb3y5b"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "335.095px 93.585px"
    },
    className: "animable",
    id: "eligl68rqk4fh"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "332 96.51 338.29 94.18 338.25 90.66 331.9 93.08 332 96.51",
    id: "elg9j9ghtlrxf",
    className: "animable",
    style: {
      transformOrigin: "335.095px 93.585px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M336.91,90.45a6.5,6.5,0,0,0-.25,2.6,6.53,6.53,0,0,0,.3,2.59,6.26,6.26,0,0,0,.25-2.6A6.53,6.53,0,0,0,336.91,90.45Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "336.937px 93.045px"
    },
    id: "eli872ypa2cc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335,91.15a6.43,6.43,0,0,0-.24,2.6,6.32,6.32,0,0,0,.3,2.59,6.36,6.36,0,0,0,.24-2.6A6.32,6.32,0,0,0,335,91.15Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "335.031px 93.745px"
    },
    id: "elggh6qvryk1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.18,91.6a6.46,6.46,0,0,0-.25,2.6,6.53,6.53,0,0,0,.3,2.59,6.5,6.5,0,0,0,.25-2.6A6.53,6.53,0,0,0,333.18,91.6Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "333.205px 94.195px"
    },
    id: "ellu0j0zfzbu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.47,134.49l.68-4.89.46-13-.5-9.09s3,.23,4.67,4.15,1.7,9.91,1.7,9.91,12.7,5,8.22,17",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "347.564px 123.04px"
    },
    id: "el2rbqdw0qjva",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.66,114.66a4.93,4.93,0,0,0-.58-2.93,4.22,4.22,0,0,0-2.83-1.76,8.09,8.09,0,0,0-3.1,0l2.39,3.33a48.16,48.16,0,0,0-1.06,6.09c-.13,1.05-.12,2.36.79,2.9a2,2,0,0,0,2.34-.53,5.69,5.69,0,0,0,1.08-2.35A21.66,21.66,0,0,0,356.66,114.66Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "353.421px 116.142px"
    },
    id: "elfbkatc34la5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.25,118.51a5.08,5.08,0,0,0-.58-2.93,4.22,4.22,0,0,0-2.84-1.76,8,8,0,0,0-3.09,0l2.38,3.33a50,50,0,0,0-1.06,6.09c-.12,1-.12,2.36.8,2.9a2,2,0,0,0,2.34-.53,5.67,5.67,0,0,0,1.07-2.35A21.68,21.68,0,0,0,360.25,118.51Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "357.008px 119.992px"
    },
    id: "elhfy7p1ga5ep",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364,122.31a5,5,0,0,0-.58-2.94,4.22,4.22,0,0,0-2.83-1.76,8.5,8.5,0,0,0-3.1,0l2.39,3.33a48.16,48.16,0,0,0-1.06,6.09c-.13,1.06-.12,2.36.79,2.91a2,2,0,0,0,2.34-.54A5.75,5.75,0,0,0,363,127,21.7,21.7,0,0,0,364,122.31Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "360.76px 123.789px"
    },
    id: "elt4so135zwnj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.4,112.31a9.27,9.27,0,0,1,.19,4.44,9.42,9.42,0,0,1-1.41,4.21c-.15-.06.57-1.9.9-4.29S356.25,112.33,356.4,112.31Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "355.967px 116.635px"
    },
    id: "elwb3teuyo54m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.24,117.53a9.33,9.33,0,0,1-1.59,7.49c-.14-.08.67-1.62,1.09-3.68S360.08,117.54,360.24,117.53Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "359.543px 121.275px"
    },
    id: "el7n2ni748d9b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345,112.31a17.2,17.2,0,0,1,.55,2.62c.29,1.65.68,4,1.12,6.77l-.16-.2a13.67,13.67,0,0,1,8.28,8,14.1,14.1,0,0,1,1,4.79,13.73,13.73,0,0,1-.31,3.28,4.1,4.1,0,0,1-.34,1.16,27.07,27.07,0,0,0,.28-4.42,14.36,14.36,0,0,0-1.08-4.63,13.6,13.6,0,0,0-3.26-4.78,13.36,13.36,0,0,0-4.74-2.92l-.14,0,0-.14c-.4-2.77-.72-5.13-.93-6.8A19.08,19.08,0,0,1,345,112.31Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "350.397px 125.52px"
    },
    id: "elxwebimk9j7d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.68,85.46l-.22.09-.64.24-2.36.88-7.76,3-7.75,3-2.36.88-.65.23c-.14.06-.22.08-.22.07l.21-.1.63-.27,2.33-1c2-.79,4.71-1.87,7.73-3s5.78-2.19,7.79-2.9c1-.35,1.81-.63,2.38-.81l.65-.21A.79.79,0,0,1,343.68,85.46Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "332.7px 89.6562px"
    },
    id: "ellwy4p7cpxo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.83,201.82s12.46-3.41,14.59-3.49c1.63-.05,11.08,1.55,15.43,2.3a3.16,3.16,0,0,1,2.67,3.51,2.63,2.63,0,0,1-.08.3,2.87,2.87,0,0,1-2.4,1.84,3.34,3.34,0,0,1,1.82,3.46c-.34,2.46-3.39,2.53-3.39,2.53s.15.16.36.44a3,3,0,0,1-2.19,4.71l-1.39.1a2.94,2.94,0,0,1,1.42,2.72c-.54,3.23-7.92,2.74-7.92,2.74l-19.82-.38Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "272.737px 210.668px"
    },
    id: "elltlxxq09y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.76,196.55c-.24,1-.84,3.29-2.81,4l-10-1.92s7.87-1.44,9.12-2.56a8.82,8.82,0,0,1,1.65-1.18A1.44,1.44,0,0,1,285.76,196.55Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "279.38px 197.643px"
    },
    id: "elwhpxztpq26",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.71,199.29c0,.17,2,.68,4.53,1s4.59.56,4.62.37-2-.68-4.53-1S277.74,199.11,277.71,199.29Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "282.285px 199.977px"
    },
    id: "ellf1nfrrqyo9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.11,205.23c0,.17,1.68.75,3.89,1s4,.09,4-.09-1.77-.31-3.94-.56S279.15,205.05,279.11,205.23Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "283.055px 205.766px"
    },
    id: "elms6u2fpma6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.11,203.74c-.16.07-.05.65.46,1.1s1.09.49,1.14.32-.31-.46-.7-.81S274.28,203.66,274.11,203.74Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "274.878px 204.49px"
    },
    id: "elj8arw5dmpnt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,211.42c0,.18,1.91.56,4.29.84s4.35.37,4.38.19-1.9-.55-4.3-.84S277.05,211.24,277,211.42Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "281.335px 211.934px"
    },
    id: "elidilw0wsqsh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.71,207.87c-.08,0-.26.14-.37.53a2.08,2.08,0,0,0,.21,1.53,2.12,2.12,0,0,0,1.21,1c.38.1.63,0,.64-.05s-.82-.42-1.28-1.25S271.88,207.93,271.71,207.87Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "272.339px 209.421px"
    },
    id: "elorry2w1mhv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.57,217.41c0,.18,1.76.38,3.93.44s3.94,0,3.94-.21-1.75-.38-3.92-.44S274.58,217.23,274.57,217.41Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "278.505px 217.527px"
    },
    id: "el1l9hcjuedyw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.46,213.4c-.08,0-.24.17-.29.56a2.53,2.53,0,0,0,.33,1.45c.6,1,1.38,1.45,1.49,1.34s-.42-.82-.92-1.66S269.62,213.45,269.46,213.4Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "270.084px 215.083px"
    },
    id: "eldxcztm3zqpl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.87,103.29c-.4-3.21-3.92-5.46-7.11-5a8.64,8.64,0,0,0-6.64,6.3,13.94,13.94,0,0,0,1,9.42c1,2.32,2.76,4.61,5.25,5.12a6.81,6.81,0,0,0,6.19-2.47,20,20,0,0,0,3.3-6.12Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "211.789px 108.71px"
    },
    id: "elu1yiof89ykl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.93,102.59a2.53,2.53,0,0,0-3.2.71,5.44,5.44,0,0,0-1,3.37,13.63,13.63,0,0,0,1.12,5.81,2.08,2.08,0,0,0,1.14,1.31,1.49,1.49,0,0,0,1.52-.56,3.68,3.68,0,0,0,.67-1.57,18.05,18.05,0,0,0-.49-10.09",
    style: {
      fill: "#0C3450",
      transformOrigin: "220.201px 107.698px"
    },
    id: "elc6aqnc43jrq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.59,87.15c5.62-2.75,8.85-5.6,8.38-7.93s-11.78-5.94-14.43-6.92c-6.25-2.32-12.16,3.2-22,5.18-19.17,3.85-33.93,10.87-33,15.68.46,2.32,4.5,3.7,10.7,4.08",
    style: {
      fill: "#0C3450",
      transformOrigin: "252.257px 84.4903px"
    },
    id: "el69hsy5x2dwq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el7dofestw65i"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "251.919px 86.536px"
    },
    className: "animable",
    id: "el86nm32e95qu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.24,87.65c5-2.44,8-5,7.43-7-1.52-5.66-15.32-5-32.32-1.54S220.28,88.71,221.14,93c.41,2.06,4,3.28,9.48,3.62",
    id: "eladd2f2mkybh",
    className: "animable",
    style: {
      transformOrigin: "251.919px 86.536px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M230.65,94.82a24,24,0,0,1,20.06-27.94c12.69-1.89,24.52,7,27.11,19.55,2.27,11,4.31,22.15,4.48,26.22.5,12.28-6.43,17.44-9.26,19a15.92,15.92,0,0,1-3.19,1h0a.08.08,0,0,0-.06.1l3.48,13.94c1.73,9.17-3,17.67-12.13,19.51s-16.78-4.86-18.69-14Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "256.302px 116.566px"
    },
    id: "elt9jvjjbuln9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.07,94.08a2,2,0,0,1-1.46,2.31,1.87,1.87,0,0,1-2.32-1.33,2,2,0,0,1,1.46-2.31A1.87,1.87,0,0,1,274.07,94.08Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "272.18px 94.57px"
    },
    id: "elzvcna9ljqa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.17,89.92c-.19.29-1.86-.49-3.92-.07s-3.36,1.75-3.63,1.55,0-.59.58-1.2a5.3,5.3,0,0,1,2.85-1.55,5.16,5.16,0,0,1,3.18.36C275,89.37,275.26,89.78,275.17,89.92Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "271.351px 89.9824px"
    },
    id: "el0rh9lmq5azq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.81,98.15a2,2,0,0,1-1.46,2.31A1.88,1.88,0,0,1,250,99.13a2,2,0,0,1,1.46-2.31A1.87,1.87,0,0,1,253.81,98.15Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "251.905px 98.6387px"
    },
    id: "el3680jppdpo9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255,94.37c-.18.3-1.85-.48-3.91-.07s-3.36,1.76-3.64,1.55c-.13-.09,0-.59.58-1.2a5.45,5.45,0,0,1,2.85-1.55,5.15,5.15,0,0,1,3.18.37C254.77,93.83,255.08,94.23,255,94.37Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "251.208px 94.4346px"
    },
    id: "elwe6zunc21g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.54,108.15a14,14,0,0,1,3.22-1.27c.52-.16,1-.37,1-.74a2.75,2.75,0,0,0-.66-1.49l-2.37-3.7c-3.3-5.27-5.81-9.65-5.6-9.78s3.07,4,6.38,9.31l2.3,3.73a3.11,3.11,0,0,1,.69,2,1.32,1.32,0,0,1-.71.94,3.4,3.4,0,0,1-.87.31A13.35,13.35,0,0,1,265.54,108.15Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "265.809px 99.6585px"
    },
    id: "elxpaxjmcc7ub",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.77,132.68s-7.83,2.25-19-1.74c0,0,5.26,9.89,19.92,5.49Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "260.73px 134.249px"
    },
    id: "el7rxemlfera7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.66,113.3a3.79,3.79,0,0,0-3.61-.71,3.43,3.43,0,0,0-2.08,1.72,2.17,2.17,0,0,0,.33,2.49,2.52,2.52,0,0,0,2.83.14,7.73,7.73,0,0,0,2.32-2.1,2.18,2.18,0,0,0,.47-.73.7.7,0,0,0-.16-.76",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "262.845px 114.857px"
    },
    id: "eldptpdshcyqa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.76,110.8c.33-.09.78,2.15,3,3.35s4.57.48,4.65.79c.06.13-.44.54-1.44.77a5.69,5.69,0,0,1-3.86-.53,5,5,0,0,1-2.39-2.84C259.46,111.42,259.6,110.82,259.76,110.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "263.495px 113.318px"
    },
    id: "elqpmt13v2zwd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.45,87.72c-.09.6-2.2.75-4.56,1.53s-4.19,1.83-4.61,1.39c-.19-.21.05-.81.73-1.51a8.31,8.31,0,0,1,7-2.22C254,87.09,254.48,87.44,254.45,87.72Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "249.834px 88.78px"
    },
    id: "elkwgnr41fouk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.35,84.76c-.27.54-1.79.34-3.5.66s-3.09,1-3.53.52c-.19-.21-.06-.72.49-1.29a5.14,5.14,0,0,1,5.65-1C273.16,84.05,273.46,84.5,273.35,84.76Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "269.805px 84.6579px"
    },
    id: "el4zg2icou2kw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.63,75.1a13.39,13.39,0,0,1-8.56,7.57c-2.49.71-5.45.84-7,2.89-1.15,1.5-1.15,3.54-1.41,5.41-.41,2.85.31,6.13-1.86,8-1.7,1.47-3.3,1.43-4.34,3.42s-.84,4.8-.41,7.13,1,6-.91,7.48c-1.78-8.44-6.34-17.47-8.11-25.91a10.31,10.31,0,0,1-.32-3.82c.5-2.86,3.24-4.72,5.83-6,7.35-3.68,15.45-5.57,23.45-7.43",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "243.142px 95.42px"
    },
    id: "elzimqvd5xe29",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.74,77.92s-9.06-19.41-9.69-20.32-8.23-8.67-22.64-8.44l-11.49,2.31S222.66,60,220.48,64.56s.42,24.12.42,24.12l30.81-13.47,23,.94Z",
    style: {
      fill: "#0C3450",
      transformOrigin: "250.675px 68.9175px"
    },
    id: "el9n4qj7gon4e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.18,47.58l3.17-.64a3.3,3.3,0,0,1,3.38,1.35,10.18,10.18,0,0,1,1.38,3.09c.95,3.53,6.68,27.87,6.68,27.87l-14.54,2.23-5.61-30.35L235,53.19l-.09-.9a2.7,2.7,0,0,1,.31-1.58h0a2.64,2.64,0,0,1,1.76-1.31Z",
    style: {
      fill: "#0C3450",
      transformOrigin: "247.342px 64.1757px"
    },
    id: "elrht66xu1lyq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.11,80.77,275.17,74,251.24,71.5,225.77,84.91l1.6,8S248.32,79.2,278.11,80.77Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "251.94px 82.205px"
    },
    id: "elwyvvn1vi8jo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.54,72.3l1.14.73,8.74,4.15s-15.79-2-31.26,1.26S219,90.52,219,90.52l9-8.24h0a18.1,18.1,0,0,1,11.46-8.14l19.39-4.29A18,18,0,0,1,272.54,72.3Z",
    style: {
      fill: "#0C3450",
      transformOrigin: "250.71px 79.969px"
    },
    id: "elts6sfzh4jf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.26,77.91s-.18-.14-.57-.33a9.1,9.1,0,0,0-1.76-.67,28.41,28.41,0,0,0-6.84-.94,73.84,73.84,0,0,0-22.45,3.14c-4.26,1.18-8.35,2.22-12,3.51a92.37,92.37,0,0,0-9.39,4c-1.3.65-2.45,1.31-3.43,1.93a6.51,6.51,0,0,0-2.26,2,2.7,2.7,0,0,0-.38,1.88c.1.44.27.62.29.61a2.66,2.66,0,0,1,.38-2.31A6.41,6.41,0,0,1,224.08,89c1-.58,2.15-1.18,3.45-1.8,2.61-1.2,5.81-2.57,9.38-3.83s7.69-2.25,12-3.43a80.13,80.13,0,0,1,22.21-3.36,32.5,32.5,0,0,1,6.76.65C279.42,77.57,280.21,78,280.26,77.91Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "250.702px 84.501px"
    },
    id: "elgywbf0w2szr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278,80.55c2.77,6.19,12.43,15,3.17,23.55,0,0-2.92-14-5.16-19.23a11.32,11.32,0,0,0-2.68-4.21",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "279.213px 92.325px"
    },
    id: "el9aq4uzp81t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.51,92.13a12.5,12.5,0,0,0-10,14.07c.31,1.65,1,3.28.79,5s-1.08,3.07-1.49,4.66c-.81,3.14-1,8.31.11,11.38,2.54,7.3,11.8,16.3,20.19,14.62",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "229.627px 117.097px"
    },
    id: "elqy09zpgbr88",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.72,135.81a5.51,5.51,0,0,0,4.89-1.47,10.17,10.17,0,0,0,2.59-4.57,17.81,17.81,0,0,0-3.26-16.09,26.12,26.12,0,0,0,.32-24.7L229.5,92.46Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "237.195px 112.444px"
    },
    id: "ela38w43pz49i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218,110.48a5.17,5.17,0,0,1-1.86,1.67,9.05,9.05,0,0,1-5.9,1.29,8.87,8.87,0,0,1-5.41-2.68,3.69,3.69,0,0,1-1.15-2.23,9.06,9.06,0,0,0,1.41,2,9.31,9.31,0,0,0,5.21,2.42,9.44,9.44,0,0,0,5.65-1.1C217.27,111.11,217.93,110.41,218,110.48Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "210.84px 111.02px"
    },
    id: "ellvpchjm8lag",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.1,108.9a5,5,0,0,1-2.07.74,10.61,10.61,0,0,1-9.81-3.16,5.08,5.08,0,0,1-1.24-1.82c.07,0,.54.65,1.5,1.56a11.5,11.5,0,0,0,9.49,3.06C216.28,109.1,217.07,108.82,217.1,108.9Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "210.54px 107.251px"
    },
    id: "elgucxv7j7lci",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.63,92.22a4.23,4.23,0,0,1-.07,1.18,16,16,0,0,1-.75,3.15,17.69,17.69,0,0,1-16.23,12,15.61,15.61,0,0,1-3.23-.21,4.08,4.08,0,0,1-1.15-.29,33.4,33.4,0,0,0,4.36.13,18.08,18.08,0,0,0,15.91-11.74A37.42,37.42,0,0,0,242.63,92.22Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "231.922px 100.391px"
    },
    id: "elhrwbvdbaq8r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,109.85s-.17.28-.58.69a10,10,0,0,1-2,1.5,15.53,15.53,0,0,1-7.87,2,31.3,31.3,0,0,1-8-1.24c-1-.28-1.8-.52-2.35-.71a3.23,3.23,0,0,1-.84-.33,25.67,25.67,0,0,1,3.28.68,36.84,36.84,0,0,0,7.94,1.08,16.49,16.49,0,0,0,7.69-1.79A25.93,25.93,0,0,0,243,109.85Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "232.18px 111.946px"
    },
    id: "el614b745s333",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.25,75.9a3.19,3.19,0,0,1-.7-.2L279.61,75l-7.13-2.56h0l0,0-1.84-1.65a11.24,11.24,0,0,0-2.06-1.62,6.69,6.69,0,0,0-2.63-.81,11.76,11.76,0,0,0-3,.28c-4.08.68-8.55,1.63-13.21,2.71-4.33,1-8.47,2-12.25,3a8.38,8.38,0,0,0-2.61,1A6.33,6.33,0,0,0,233,77.08c-.93,1.45-1.75,2.91-2.53,4.2l0,0,0,0-6.93,5.12-1.91,1.38a4.85,4.85,0,0,1-.68.45,4.19,4.19,0,0,1,.62-.54l1.84-1.46L230.13,81l0,.06c.78-1.32,1.55-2.75,2.51-4.27a6.85,6.85,0,0,1,2-1.9,8.85,8.85,0,0,1,2.73-1c3.78-1,7.91-2,12.26-3,4.66-1.08,9.14-2,13.25-2.69a11.73,11.73,0,0,1,3.07-.25,7,7,0,0,1,2.8.88,11.37,11.37,0,0,1,2.12,1.7l1.81,1.67-.06,0,7.08,2.71,1.91.76A4.9,4.9,0,0,1,282.25,75.9Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "251.6px 78.0825px"
    },
    id: "el03qd4dfoesch",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.58,72.54a4.68,4.68,0,0,1-.28-1c-.15-.65-.35-1.58-.59-2.74-.47-2.31-1.09-5.51-1.75-9-.31-1.77-.62-3.45-.9-5-.13-.76-.25-1.49-.37-2.18a.93.93,0,0,0-1.18-.76l-2.57,1a3.34,3.34,0,0,1-1,.32,4.29,4.29,0,0,1,.9-.5c.6-.3,1.43-.71,2.54-1.21a1.32,1.32,0,0,1,1.71,1c.14.69.28,1.42.43,2.18.29,1.54.6,3.22.94,5,.65,3.54,1.21,6.75,1.59,9.08.19,1.16.34,2.11.43,2.76A3.48,3.48,0,0,1,243.58,72.54Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "239.263px 61.9716px"
    },
    id: "ellkf6nob5sf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.47,69.45a13.74,13.74,0,0,1-1.05-2.89c-.55-1.82-1.18-4.36-1.85-7.17s-1.24-5.37-1.63-7.22a17.33,17.33,0,0,1-.52-3,18.35,18.35,0,0,1,.88,3c.48,1.83,1.11,4.37,1.78,7.18s1.23,5.2,1.7,7.2A25,25,0,0,1,257.47,69.45Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "254.945px 59.31px"
    },
    id: "elz786f43zwds",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282,109.64a16.09,16.09,0,0,0,5.94-1.42,12.74,12.74,0,0,0,5.13-4,9.63,9.63,0,0,0,1.26-7.68,10.08,10.08,0,0,0-4.52-6.38,63.27,63.27,0,0,0-6.12-2.67A10.41,10.41,0,0,1,280,84.81a5.68,5.68,0,0,1-.69-1c-.12-.25-.18-.39-.16-.4a14.9,14.9,0,0,0,1,1.31,11,11,0,0,0,3.71,2.44,56.64,56.64,0,0,1,6.22,2.6,10.41,10.41,0,0,1,4.77,6.67,10,10,0,0,1-1.37,8.08,12.83,12.83,0,0,1-5.37,4.09,14,14,0,0,1-4.42,1.12,8.65,8.65,0,0,1-1.24,0A1.15,1.15,0,0,1,282,109.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "287.159px 96.5761px"
    },
    id: "elkn32dlcczzg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.15,105.66s-.09,0-.23-.17a4.39,4.39,0,0,1-.55-.6,6.24,6.24,0,0,1-1.13-2.75,6.61,6.61,0,0,1,.79-4.35,6.53,6.53,0,0,1,9.69-1.46,6.61,6.61,0,0,1,2.05,3.91,6.35,6.35,0,0,1-.27,3,3.57,3.57,0,0,1-.35.73c-.09.16-.15.24-.16.23s.14-.36.31-1a6.73,6.73,0,0,0,.11-2.85,6.37,6.37,0,0,0-2-3.61,6.15,6.15,0,0,0-9,1.35,6.43,6.43,0,0,0-.84,4,6.71,6.71,0,0,0,.94,2.68C206.91,105.35,207.18,105.62,207.15,105.66Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "211.498px 100.229px"
    },
    id: "eld9ber0pjty",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.27,140.2a1.37,1.37,0,0,1-.42.15c-.28.09-.69.19-1.23.32a27.45,27.45,0,0,1-4.64.69,15.17,15.17,0,0,1-6.87-1.06,13.26,13.26,0,0,1-6.18-5.82,17.33,17.33,0,0,1-2.09-8.25,24.4,24.4,0,0,1,1-6.89,32.25,32.25,0,0,1,1.64-4.38c.23-.5.42-.89.56-1.14a1.73,1.73,0,0,1,.23-.38,13.81,13.81,0,0,1-.6,1.6,38.94,38.94,0,0,0-1.47,4.4,24.89,24.89,0,0,0-.91,6.78,17,17,0,0,0,2.07,8,12.85,12.85,0,0,0,5.91,5.63A15.29,15.29,0,0,0,232,141a32.51,32.51,0,0,0,4.61-.52A12.92,12.92,0,0,1,238.27,140.2Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "227.555px 127.423px"
    },
    id: "eltcwa48xd3j9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.93,115.51a1.42,1.42,0,0,1-.12.47,5.51,5.51,0,0,1-.64,1.27,7.53,7.53,0,0,1-4.19,3,7.44,7.44,0,0,1-3.6.16,8.91,8.91,0,0,1-3.76-1.76,10.14,10.14,0,0,1-2.86-3.57,11.39,11.39,0,0,1-1.06-4.8,13.78,13.78,0,0,1,3.12-8.79,8.72,8.72,0,0,1,6.74-3.42,6.9,6.9,0,0,1,4.77,1.88,3.92,3.92,0,0,1,1.07,1.56,9.26,9.26,0,0,0-1.2-1.41,6.9,6.9,0,0,0-4.64-1.66,8.39,8.39,0,0,0-6.37,3.35,13.47,13.47,0,0,0-3,8.49,11,11,0,0,0,1,4.58,9.87,9.87,0,0,0,2.7,3.42,8.73,8.73,0,0,0,3.54,1.71,7.29,7.29,0,0,0,3.43-.1,7.58,7.58,0,0,0,4.12-2.74A11.75,11.75,0,0,0,216.93,115.51Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "208.815px 109.314px"
    },
    id: "ela3bc83purt9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.74,
    y: 223.59,
    width: 354.59,
    height: 234.49,
    rx: 14.57,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "340.035px 340.835px"
    },
    id: "elg0unkwkmzfr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.88,442.94H533.05a0,0,0,0,1,0,0v2.72a17.8,17.8,0,0,1-17.8,17.8H166.68a17.8,17.8,0,0,1-17.8-17.8v-2.72A0,0,0,0,1,148.88,442.94Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "340.965px 453.2px"
    },
    id: "elikhpoy6st4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.26,
    y: 232.91,
    width: 334.56,
    height: 198.02,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "339.54px 331.92px"
    },
    id: "el1ebpk47npup",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.08 440.74 309.85 448.32 376.93 448.32 381.36 440.74 305.08 440.74",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "343.22px 444.53px"
    },
    id: "el2sktqpmq2jv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.15,
    y: 239.61,
    width: 321.47,
    height: 190.68,
    rx: 3.27,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "339.885px 334.95px"
    },
    id: "eltpeij86ycur",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "500.27 430.58 178.81 430.58 179.15 253.87 500.27 253.87 500.27 430.58",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "339.54px 342.225px"
    },
    id: "elrl0lxahatbi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.51,247a2.57,2.57,0,1,1-2.56-2.57A2.56,2.56,0,0,1,205.51,247Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "202.94px 247px"
    },
    id: "el7ycreqvf7k6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,247a2.57,2.57,0,1,1-2.56-2.57A2.56,2.56,0,0,1,190,247Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "187.43px 247px"
    },
    id: "elapmxu1yf4i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.42,247a2.57,2.57,0,1,1-2.56-2.57A2.57,2.57,0,0,1,197.42,247Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "194.85px 247px"
    },
    id: "elyz7lj80dgl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.28,440.74c0,.13-78.7.23-175.76.23s-175.78-.1-175.78-.23,78.69-.23,175.78-.23S514.28,440.61,514.28,440.74Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "338.51px 440.74px"
    },
    id: "el7uy23ciirx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.92,396.09c0,.14-19.28.26-43.06.26s-43.06-.12-43.06-.26,19.28-.26,43.06-.26S380.92,396,380.92,396.09Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "337.86px 396.09px"
    },
    id: "elkdlzewx546",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.58,
    y: 350.8,
    width: 95.93,
    height: 72.1,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "234.545px 386.85px"
    },
    id: "elutsqpy8bkz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.62 422.95 220.08 378.1 240.86 406.12 254.93 391.12 282.55 422.86 186.62 422.95",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "234.585px 400.525px"
    },
    id: "elkpwi2r64o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.64,372.58a7.55,7.55,0,1,1-7.56-7.54A7.54,7.54,0,0,1,249.64,372.58Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "242.09px 372.59px"
    },
    id: "el0y79gduebj2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.57,
    y: 350.91,
    width: 95.93,
    height: 72.1,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "441.535px 386.96px"
    },
    id: "elgan034kxkka",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.6 423.06 427.07 378.21 447.85 406.23 461.91 391.23 489.53 422.97 393.6 423.06",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "441.565px 400.635px"
    },
    id: "elbmf5ukatpgd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.63,372.69a7.56,7.56,0,1,1-7.56-7.55A7.56,7.56,0,0,1,456.63,372.69Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "449.07px 372.7px"
    },
    id: "el2dtypaalcl9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.32,336.58a13.61,13.61,0,0,1,2.69-.18c1.66,0,4-.08,6.49-.08h2.82l-.25.25c0-1.85.05-3.44.1-4.57a7.46,7.46,0,0,1,.15-1.79,7.72,7.72,0,0,1,.16,1.79c0,1.13.07,2.72.09,4.57v.25H483.5c-2.53,0-4.83,0-6.49-.08A13.61,13.61,0,0,1,474.32,336.58Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "480.445px 333.515px"
    },
    id: "el99iqbhf3uh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.32,336.58a69.36,69.36,0,0,1,12,0,69.36,69.36,0,0,1-12,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "456.32px 336.58px"
    },
    id: "el3fcykqm7mt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.32,336.58a69.36,69.36,0,0,1,12,0,69.36,69.36,0,0,1-12,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "432.32px 336.58px"
    },
    id: "elo4n5iccu50e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.32,336.58a69.36,69.36,0,0,1,12,0,69.36,69.36,0,0,1-12,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "408.32px 336.58px"
    },
    id: "eleal45inevgo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.32,336.58a69.36,69.36,0,0,1,12,0,69.36,69.36,0,0,1-12,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "384.32px 336.58px"
    },
    id: "elzc44bsjypbr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.32,336.58a69.36,69.36,0,0,1,12,0,69.36,69.36,0,0,1-12,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "360.32px 336.58px"
    },
    id: "elipo4jlxcnao",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.32,336.58a69.36,69.36,0,0,1,12,0,69.36,69.36,0,0,1-12,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "336.32px 336.58px"
    },
    id: "elbgnetithqwl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.32,336.58a69.36,69.36,0,0,1,12,0,69.36,69.36,0,0,1-12,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "312.32px 336.58px"
    },
    id: "eldd8b4ymeps",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.32,336.58a35.32,35.32,0,0,1,6-.26,35.22,35.22,0,0,1,6,.26,35.22,35.22,0,0,1-6,.26A35.32,35.32,0,0,1,282.32,336.58Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "288.32px 336.58px"
    },
    id: "elfafxo9zwrd7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.32,336.58a35.32,35.32,0,0,1,6-.26,35.22,35.22,0,0,1,6,.26,35.22,35.22,0,0,1-6,.26A35.32,35.32,0,0,1,258.32,336.58Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "264.32px 336.58px"
    },
    id: "el4p3usx5hsb4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.32,336.58a35.32,35.32,0,0,1,6-.26,35.22,35.22,0,0,1,6,.26,35.22,35.22,0,0,1-6,.26A35.32,35.32,0,0,1,234.32,336.58Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "240.32px 336.58px"
    },
    id: "elkvt5pmgzrt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.32,336.58a35.32,35.32,0,0,1,6-.26,35.22,35.22,0,0,1,6,.26,35.22,35.22,0,0,1-6,.26A35.32,35.32,0,0,1,210.32,336.58Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "216.32px 336.58px"
    },
    id: "elsqovxkn9lb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.34,336.57h0a36.74,36.74,0,0,1,6-.25,35.22,35.22,0,0,1,6,.26,35.22,35.22,0,0,1-6,.26,36.74,36.74,0,0,1-6-.25h0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "192.34px 336.58px"
    },
    id: "el3cani2ahadl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.34,312.57a69.36,69.36,0,0,1,0,12,69.36,69.36,0,0,1,0-12Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "186.34px 318.57px"
    },
    id: "eluu8cghqfw9k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.34,288.57a35.22,35.22,0,0,1,.26,6,35.32,35.32,0,0,1-.26,6,34.12,34.12,0,0,1-.26-6A34,34,0,0,1,186.34,288.57Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "186.338px 294.57px"
    },
    id: "elu6z7absec1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.34,264.57a35.22,35.22,0,0,1,.26,6,35.32,35.32,0,0,1-.26,6,34.12,34.12,0,0,1-.26-6A34,34,0,0,1,186.34,264.57Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "186.338px 270.57px"
    },
    id: "el9j8j6hsqxym",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.16,261.39a35.32,35.32,0,0,1-6,.26,35.22,35.22,0,0,1-6-.26,34,34,0,0,1,6-.26A34.12,34.12,0,0,1,207.16,261.39Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "201.16px 261.388px"
    },
    id: "el32j5guwsp1x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.16,261.39a35.32,35.32,0,0,1-6,.26,35.22,35.22,0,0,1-6-.26,34,34,0,0,1,6-.26A34.12,34.12,0,0,1,231.16,261.39Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "225.16px 261.388px"
    },
    id: "elsvaz3p74dbl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.16,261.39a35.32,35.32,0,0,1-6,.26,35.22,35.22,0,0,1-6-.26,34,34,0,0,1,6-.26A34.12,34.12,0,0,1,255.16,261.39Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "249.16px 261.388px"
    },
    id: "elo71l4cpthih",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.16,261.39a35.32,35.32,0,0,1-6,.26,35.22,35.22,0,0,1-6-.26,34,34,0,0,1,6-.26A34.12,34.12,0,0,1,279.16,261.39Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "273.16px 261.388px"
    },
    id: "elffui3vfg5cb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.16,261.39a69.36,69.36,0,0,1-12,0,34,34,0,0,1,6-.26A34.12,34.12,0,0,1,303.16,261.39Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "297.16px 261.373px"
    },
    id: "elxvj79jes0co",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.16,261.39a69.36,69.36,0,0,1-12,0,69.36,69.36,0,0,1,12,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "321.16px 261.39px"
    },
    id: "elz6zxvz87khg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.16,261.39a69.36,69.36,0,0,1-12,0,69.36,69.36,0,0,1,12,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "345.16px 261.39px"
    },
    id: "elq3ra7kyx5g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.16,261.39a69.36,69.36,0,0,1-12,0,69.36,69.36,0,0,1,12,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "369.16px 261.39px"
    },
    id: "elwtiq70jn5g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.16,261.39a69.36,69.36,0,0,1-12,0,69.36,69.36,0,0,1,12,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "393.16px 261.39px"
    },
    id: "elay7kg8iz44e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.16,261.39a69.36,69.36,0,0,1-12,0,69.36,69.36,0,0,1,12,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "417.16px 261.39px"
    },
    id: "elx30oeph6dto",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.16,261.39a69.36,69.36,0,0,1-12,0,69.36,69.36,0,0,1,12,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "441.16px 261.39px"
    },
    id: "eln5s962mykwg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.16,261.39a69.36,69.36,0,0,1-12,0,69.36,69.36,0,0,1,12,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "465.16px 261.39px"
    },
    id: "elkukvprndv6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.32,270.22a35.32,35.32,0,0,1-.26-6c0-1,0-1.94,0-2.83l.23.23a14.39,14.39,0,0,1-3.16-.23,13.67,13.67,0,0,1,3.16-.23h.23v.24c0,.89,0,1.83,0,2.83A34.12,34.12,0,0,1,486.32,270.22Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "484.85px 265.684px"
    },
    id: "elkujw166x6o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.32,294.22a35.32,35.32,0,0,1-.26-6,35.32,35.32,0,0,1,.26-6,34.12,34.12,0,0,1,.26,6A34.12,34.12,0,0,1,486.32,294.22Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "486.322px 288.22px"
    },
    id: "elun9h1e2ue9g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.32,318.22a69.36,69.36,0,0,1,0-12,69.36,69.36,0,0,1,0,12Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "486.32px 312.22px"
    },
    id: "elw9sfiivtxe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.92,420.4c0,.15-19.28.26-43.06.26s-43.06-.11-43.06-.26,19.28-.26,43.06-.26S380.92,420.26,380.92,420.4Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "337.86px 420.4px"
    },
    id: "elqklpzt2cm4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.92,409.28c0,.14-19.28.26-43.06.26s-43.06-.12-43.06-.26,19.28-.26,43.06-.26S380.92,409.14,380.92,409.28Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "337.86px 409.28px"
    },
    id: "el64z3p0dwpds",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sign--inject-139",
    className: "animable",
    style: {
      transformOrigin: "114.57px 365.765px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.98,
    y: 323.53,
    width: 5.18,
    height: 139.73,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "114.57px 393.395px"
    },
    id: "elayheecazrfq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.57,
    cy: 298.39,
    r: 30.12,
    style: {
      fill: "#0C3450",
      transformOrigin: "114.57px 298.39px"
    },
    id: "eloogau0ppgf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.69,298a2.19,2.19,0,0,1-.05-.44c0-.31,0-.74-.09-1.28,0-.29,0-.6-.06-.95s-.12-.72-.18-1.13a18.71,18.71,0,0,0-.57-2.79,25.79,25.79,0,0,0-3-7.18,27.11,27.11,0,0,0-6.86-7.63,26.82,26.82,0,0,0-25.45-3.84,27.77,27.77,0,0,0-3.5,1.54c-.57.31-1.12.67-1.68,1a14.62,14.62,0,0,0-1.62,1.12,30.84,30.84,0,0,0-3,2.59,29.39,29.39,0,0,0-2.64,3.12,26,26,0,0,0-3.83,7.4A28.51,28.51,0,0,0,87.72,298a28.88,28.88,0,0,0,1.38,8.47,26.08,26.08,0,0,0,3.84,7.41A31.53,31.53,0,0,0,95.57,317a31,31,0,0,0,3.05,2.59,14.62,14.62,0,0,0,1.62,1.12c.56.33,1.11.69,1.68,1a26.39,26.39,0,0,0,3.5,1.54,26.94,26.94,0,0,0,32.31-11.47,25.63,25.63,0,0,0,3-7.17,18.81,18.81,0,0,0,.57-2.8c.07-.4.14-.78.18-1.13s0-.66.06-.94q.06-.83.09-1.29a2.19,2.19,0,0,1,.05-.44,2.44,2.44,0,0,1,0,.44c0,.32,0,.75,0,1.29q0,.44,0,1c0,.35-.1.72-.15,1.14a20.08,20.08,0,0,1-.53,2.82,25.86,25.86,0,0,1-3,7.27,27.29,27.29,0,0,1-18.36,12.93,27.35,27.35,0,0,1-14.36-1.16,28.12,28.12,0,0,1-3.58-1.56c-.57-.31-1.13-.67-1.7-1A14.24,14.24,0,0,1,98.33,320a29.65,29.65,0,0,1-3.11-2.63,31.48,31.48,0,0,1-2.69-3.17,26.77,26.77,0,0,1-3.92-7.54,27.18,27.18,0,0,1,0-17.28,26.77,26.77,0,0,1,3.92-7.54,31.55,31.55,0,0,1,2.69-3.16A29.75,29.75,0,0,1,98.33,276a13,13,0,0,1,1.65-1.13c.57-.34,1.13-.71,1.7-1a29.62,29.62,0,0,1,3.58-1.56,27.33,27.33,0,0,1,14.36-1.15A27.24,27.24,0,0,1,138,284.1a25.79,25.79,0,0,1,3,7.28,19.82,19.82,0,0,1,.53,2.82c.05.41.12.79.15,1.14s0,.66,0,1c0,.55,0,1,0,1.29A2.44,2.44,0,0,1,141.69,298Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "114.447px 298.028px"
    },
    id: "elyew9jp40xcf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.89,
    y: 294.63,
    width: 31.37,
    height: 6.54,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "114.575px 297.9px"
    },
    id: "el2nwxgi53fus",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Crane--inject-139",
    className: "animable animator-active",
    style: {
      transformOrigin: "467.041px 270.989px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "eldd5b1uu0ufl"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 227.97,
    y: 271.38,
    width: 294.34,
    height: 85.45,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "375.14px 314.105px",
      transform: "rotate(-4.59deg)"
    },
    className: "animable",
    id: "elldqs6kvyw8o"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M525.26,344.91c-.1-1.23-2.59-31.49-7-85.16l.17.15L225.06,283.57h0l.23-.28c2.36,29.4,4.66,58,6.84,85.17l-.27-.23L441.56,351.5l83.7-6.59-1.43.13-4.24.36-16.45,1.35-61.39,5-209.86,17-.25,0,0-.26c-2.19-27.15-4.49-55.77-6.85-85.17l0-.26.26,0h0L518.4,259.57h.17v.16C522.79,313.41,525.17,343.68,525.26,344.91Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "375.025px 314.16px"
    },
    id: "elhmhvwehrxg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eld5vns6m9lzr"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 235.1,
    y: 287.67,
    width: 92.65,
    height: 69.64,
    style: {
      fill: "#0C3450",
      transformOrigin: "281.425px 322.49px",
      transform: "rotate(-4.00417deg)"
    },
    className: "animable",
    id: "eluof521hl758"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M440.82,344.88a35.57,35.57,0,0,1-6,.76l-.28-.24h0v-.29l0-.3c0-.21,0-.4,0-.6,0-.38-.06-.75-.08-1.12,0-.66-.07-1.29-.11-1.91a6.1,6.1,0,0,1,0-1.76,6,6,0,0,1,.33,1.73c.07.61.14,1.24.22,1.9,0,.36.07.74.1,1.12l.06.59,0,.31v.28h0l-.28-.24A35.92,35.92,0,0,1,440.82,344.88Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "437.553px 342.53px"
    },
    id: "el7r5ua0dufo9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468,342.59a46.18,46.18,0,0,1-6.76.83,43,43,0,0,1-6.81.31,46.18,46.18,0,0,1,6.76-.83A43,43,0,0,1,468,342.59Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "461.215px 343.16px"
    },
    id: "eljvb7klkefdg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.1,340.3a46.18,46.18,0,0,1-6.76.83,44.45,44.45,0,0,1-6.81.31,46.18,46.18,0,0,1,6.76-.83A43,43,0,0,1,495.1,340.3Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "488.315px 340.869px"
    },
    id: "eln4fn0lcuym",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.14,332.67a33.55,33.55,0,0,1,.77,5.95c-.48.57-.14.16-.24.29h-.31l-.3,0-.6,0-1.12.08-1.9.11a6.19,6.19,0,0,1-1.77,0,6.18,6.18,0,0,1,1.74-.33l1.89-.22,1.12-.11.6-.05.3,0h.3c-.1.12.24-.28-.23.28A35.36,35.36,0,0,1,514.14,332.67Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "511.79px 335.917px"
    },
    id: "elnre6usktayr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.25,310.28a59.55,59.55,0,0,1,1,11.19,30.65,30.65,0,0,1-.73-5.57A31.41,31.41,0,0,1,512.25,310.28Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "512.737px 315.875px"
    },
    id: "el2jp92e3tc2c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.36,287.9a30.09,30.09,0,0,1,.74,5.57,30.81,30.81,0,0,1,.21,5.62,29.83,29.83,0,0,1-.73-5.58A31.3,31.3,0,0,1,510.36,287.9Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "510.837px 293.495px"
    },
    id: "eljqg9j3az9gk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.93,271.23a35.78,35.78,0,0,1,6-.76l.28.24h0V271l0,.3c0,.21,0,.4,0,.6,0,.38.05.75.08,1.12,0,.66.07,1.29.1,1.91a5.93,5.93,0,0,1,0,1.76,6,6,0,0,1-.33-1.73c-.07-.61-.14-1.24-.22-1.9,0-.36-.07-.74-.11-1.12l-.05-.59,0-.31v-.28h0l.29.24A36,36,0,0,1,502.93,271.23Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "506.193px 273.58px"
    },
    id: "elnx45yhs1uon",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.8,273.52a45.68,45.68,0,0,1,6.76-.83,42.86,42.86,0,0,1,6.8-.31,45.68,45.68,0,0,1-6.76.83A42.84,42.84,0,0,1,475.8,273.52Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "482.58px 272.95px"
    },
    id: "el6cthvper0dt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.66,275.81a45.68,45.68,0,0,1,6.76-.83,44.43,44.43,0,0,1,6.81-.31,46.2,46.2,0,0,1-6.77.83A42.84,42.84,0,0,1,448.66,275.81Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "455.445px 275.241px"
    },
    id: "elrjpa1wprto",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.61,283.44a35.34,35.34,0,0,1-.76-5.95c.47-.57.13-.16.24-.28h.3l.31,0,.59-.05,1.12-.08,1.91-.11a6.19,6.19,0,0,1,1.77,0,6.3,6.3,0,0,1-1.74.33l-1.9.22-1.12.11-.59.05-.3,0h-.31l.24-.28A33.52,33.52,0,0,1,429.61,283.44Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "431.97px 280.173px"
    },
    id: "eldo4591gbs2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.5,305.83a31,31,0,0,1-.73-5.58,29.66,29.66,0,0,1-.21-5.61,30.65,30.65,0,0,1,.73,5.57A29.76,29.76,0,0,1,431.5,305.83Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "431.03px 300.235px"
    },
    id: "eleupqd755unw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.39,328.21a30.65,30.65,0,0,1-.73-5.57,29.76,29.76,0,0,1-.21-5.62,30.86,30.86,0,0,1,.73,5.58A29.66,29.66,0,0,1,433.39,328.21Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "432.92px 322.615px"
    },
    id: "el0qnlz2x2m1bq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.68 360.51 266.89 315.04 288.81 340.63 301.34 325.22 330.1 353.94 237.68 360.51",
    style: {
      fill: "#0C3450",
      transformOrigin: "283.89px 337.775px"
    },
    id: "elvvlu00bnn3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,307.72a7.3,7.3,0,1,1-7.8-6.76A7.31,7.31,0,0,1,295,307.72Z",
    style: {
      fill: "#0C3450",
      transformOrigin: "287.719px 308.242px"
    },
    id: "eljbn3q4jkzv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elpdrrgk6nand"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "283.89px 337.775px"
    },
    className: "animable",
    id: "elogu3xigojs"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "237.68 360.51 266.89 315.04 288.81 340.63 301.34 325.22 330.1 353.94 237.68 360.51",
    id: "elcn3hpgcznml",
    className: "animable",
    style: {
      transformOrigin: "283.89px 337.775px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el390vuqmh0lm"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "287.719px 308.242px"
    },
    className: "animable",
    id: "el9nqy5jqv3ln"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295,307.72a7.3,7.3,0,1,1-7.8-6.76A7.31,7.31,0,0,1,295,307.72Z",
    id: "elk9z906wu86",
    className: "animable",
    style: {
      transformOrigin: "287.719px 308.242px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M421.51,296.44c0,.15-17.95,1.92-40.12,4s-40.16,3.59-40.18,3.44,18-1.91,40.13-4S421.5,296.3,421.51,296.44Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "381.36px 300.161px"
    },
    id: "elrrhyg40q8xn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.84,309.8c0,.15-18.16,1.94-40.57,4s-40.61,3.63-40.63,3.49,18.15-1.94,40.58-4S423.82,309.66,423.84,309.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "383.24px 313.545px"
    },
    id: "elu5b8xn6uvy8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.16,323.17c0,.14-18.35,1.95-41,4s-41,3.67-41,3.53,18.34-1.95,41-4.05S426.15,323,426.16,323.17Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "385.16px 326.933px"
    },
    id: "elfmo1yqq7g9p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.64,336.41c0,.15-18.37,2-41.05,4.06s-41.1,3.67-41.11,3.53,18.37-2,41.06-4.05S426.63,336.27,426.64,336.41Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "385.56px 340.205px"
    },
    id: "elwrd5rxnj6qr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elgjjuq27ewmf"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 339.49,
    y: 289.29,
    width: 42.41,
    height: 3.36,
    style: {
      fill: "#0C3450",
      transformOrigin: "360.695px 290.97px",
      transform: "rotate(-4.59deg)"
    },
    className: "animable",
    id: "elakc0gz0lpbh"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M472.82,318.51c-.14,0-.69-4.92-1.22-11s-.84-11.05-.69-11.06.68,4.92,1.21,11S473,318.5,472.82,318.51Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "471.87px 307.48px"
    },
    id: "el85u9g1xsvj3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.06,306.94c0,.14-4.74.56-10.6.93s-10.63.56-10.63.42a104.23,104.23,0,0,1,10.6-.94C477.29,307,482.05,306.8,482.06,306.94Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "471.445px 307.616px"
    },
    id: "elvo7l7qithxi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.42,259.73s-.24-.07-.71-.25l-2-.78-7.88-3.06L478.7,244.23l-97.28-38.34h.21L369.32,212l-102,50.53L236.4,277.78,228,281.9l-2.2,1.06c-.49.24-.75.35-.75.35l.73-.4,2.17-1.1,8.38-4.21,30.86-15.41,101.92-50.67,12.31-6.11.1,0,.11,0,97.22,38.49,29,11.56,7.84,3.15,2,.83Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "371.735px 244.36px"
    },
    id: "el6f7wdeyyemd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.68,120a6.69,6.69,0,0,0-12.15-.08l-10.45.86,10.56,20.83,6.62-12.18a6.38,6.38,0,0,0,2.1-.57A6.69,6.69,0,0,0,458.68,120Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "447.68px 128.841px"
    },
    id: "elzpw19ekre2m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.36,89.84l6.82-2.91-16.45-4.14a6.69,6.69,0,1,0-1.55,8.91l15.62,9.56Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "390.794px 90.485px"
    },
    id: "elqip2zsjrf1l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530,294.3l0-.14L417.11,83.72l-.64-1.19-17.78,8.11L483.82,315l.05.14,50.7,80.59,1-.15,1.17-.17.92-.14-10.49-16.67,6.13-15.79,16.23,6,7.15,23.65.85-.12,1.08-.16,1-.14Zm7.3,34.09-20.26-5.2,11.75-22.95Zm-22.05-5.66-24.92-6.4,36.78-16.76Zm9.41-32.36-25.89-7.16,10.62-21.31ZM497,282.73l-22.79-6.3,33.55-15.29ZM506.23,256l-23.86-8.32,8.51-20.3Zm-25.56-8.91-21-7.31,29.69-13.52Zm6.83-26-21.71-9.38,6.43-19.12ZM464.13,211l-18.6-8,25.15-11.46Zm5-24.21-.12.06-19.53-10.56,4.34-18.05ZM449.87,150.9l-17-11.44,2.25-16.12Zm-18.7-12.56-13.69-9.2,16-7.29ZM416.66,89l14.46,27-14.87-12.53Zm-2.76,33.63L403.4,95l11,9.28Zm.59-20.68L402.68,92l12.25-5.58Zm1.69,3.79,14.31,12-14.85,6.77Zm.93,25.34,13.79,9.26-2.78,19.79Zm15.45,10.38,16.57,11.13-19.37,8.82Zm19.77,15.11-4.52,18.81L431,166.27Zm-21,11.94,16.06,8.68-4.95,20.6Zm17.7,9.57,17.91,9.68L444.19,198.1Zm-4,26.62,18.51,8-7.27,21.63Zm20.17,8.71,20.75,9-28.07,12.78Zm-6.24,28,21,7.32-9.56,22.83Zm22.71,7.92,22.72,7.92L472.21,271.9Zm-8.86,28.59,23.38,6.46-11.88,23.84ZM498,284.86l25.41,7-37.4,17Zm-9,33,25.48,6.54-9.59,18.72Zm27.27,7L537,330.18l-30.72,14Zm9.78,51.9-13.61-21.64,19.24,7.13Zm6.28-16.19-21.46-8-.53-.83,30-13.65.31,1Zm1.69.62L541.42,342l7.48,24.74Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "479.15px 239.13px"
    },
    id: "el9kipzzvr9iq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.35,183.29s0-.6,0-1.78,0-2.92,0-5.2c0-4.57,0-11.29-.06-19.9,0-17.23-.05-42-.09-72.3v-.19l.19,0L413,80.57h.11l.08.09,82.45,92.15,120,134.32L652,347.86l9.86,11.1,2.55,2.89c.57.65.86,1,.86,1s-.31-.32-.9-1-1.46-1.6-2.59-2.86c-2.28-2.52-5.62-6.24-9.93-11l-36.44-40.64L495.26,173.15,412.86,81l.19.08-31.68,3.28.18-.2c0,30.28-.06,55.07-.09,72.3,0,8.61,0,15.33,0,19.9,0,2.28,0,4,0,5.2S381.35,183.29,381.35,183.29Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "523.235px 221.71px"
    },
    id: "elapj1vos1aln",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.49,
    y: 155.04,
    width: 5.06,
    height: 10.85,
    rx: 0.38,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "381.02px 160.465px"
    },
    id: "elkhe1l0usin",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.61,167.57H373a1.85,1.85,0,0,1-1.85-1.85h0a1.85,1.85,0,0,1,1.85-1.85h16.62a1.85,1.85,0,0,1,1.85,1.85h0A1.85,1.85,0,0,1,389.61,167.57Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "381.31px 165.72px"
    },
    id: "el8y05nqs0k6n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.51,197.29l-.06-2.37L380,196a13.59,13.59,0,0,0,0,2.63,1.12,1.12,0,0,0,.09.41,1.18,1.18,0,0,0,.6.41,4.79,4.79,0,0,1,2.51,2.2,2.89,2.89,0,0,1-1.65,4,3,3,0,0,1-3.74-2c0-.41,0-1-.56-1-.81-.08-1.16,1.1-1.14,1.72.13,3.59,3.51,4.73,4.94,4.78a5.2,5.2,0,0,0,2.8-.6,5.42,5.42,0,0,0,2.62-3.71C387.25,200.12,382.26,197.59,382.51,197.29Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "381.331px 202.041px"
    },
    id: "elqnv9okjt2fc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.6,196.11l10.62-25.55a3.51,3.51,0,0,0-3.24-4.85H370.75a3.5,3.5,0,0,0-3.24,4.85l10.61,25.55A3.51,3.51,0,0,0,384.6,196.11Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "381.363px 181.99px"
    },
    id: "elirwfzmw20e8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.83,167.52l-2.75,2.74c0,.1,0,.21.05.31l.9,2.16,5.21-5.21Z",
    style: {
      fill: "#0C3450",
      transformOrigin: "372.16px 170.125px"
    },
    id: "ellmfbkmxgoye",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "382.08 167.52 378.66 167.52 371.03 175.15 372.04 177.56 382.08 167.52",
    style: {
      fill: "#0C3450",
      transformOrigin: "376.555px 172.54px"
    },
    id: "elo7x2g1zrzd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.38 180.72 391.8 174.88 377.05 189.63 378.05 192.04 389.38 180.72",
    style: {
      fill: "#0C3450",
      transformOrigin: "384.425px 183.46px"
    },
    id: "el0fqc8kucdfug",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,186.57l-7.89,7.89.26.64a2.14,2.14,0,0,0,1.29,1.23l3.91-3.92Z",
    style: {
      fill: "#0C3450",
      transformOrigin: "383.055px 191.45px"
    },
    id: "elaqinrg94368",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "388.91 167.52 385.5 167.52 373.04 179.97 374.04 182.39 388.91 167.52",
    style: {
      fill: "#0C3450",
      transformOrigin: "380.975px 174.955px"
    },
    id: "el7mi5quln1iu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.75,169.51a2.06,2.06,0,0,0-1.57-1.84L375,184.8l1,2.42Z",
    style: {
      fill: "#0C3450",
      transformOrigin: "384.375px 177.445px"
    },
    id: "elcxu2jyvdwd8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.77,357.34h17.84a2.64,2.64,0,0,1,2.64,2.64v8.14a0,0,0,0,1,0,0H652.13a0,0,0,0,1,0,0V360A2.64,2.64,0,0,1,654.77,357.34Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "663.69px 362.73px"
    },
    id: "el2jh6lx44slz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.73,365.44h-3.79V342.9a9.76,9.76,0,0,1,.46-2.94l1.91-5.9a.14.14,0,0,1,.25,0l2.23,4-.59,1.83a9.91,9.91,0,0,0-.47,3Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "610.365px 349.712px"
    },
    id: "el99w52mlv6te",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.14,369.54a8.25,8.25,0,0,0-6.19-5l-94.8-.05V348.74a3.83,3.83,0,0,0-3.84-3.83H554.5a3.83,3.83,0,0,0-3.65,2.66l-1.37,4.34h5.1a4,4,0,0,1,3.06,1.42,3.76,3.76,0,0,1,.8,3.2l-4.9,23.25a4,4,0,0,1-3.87,3.07h-9.73a15.33,15.33,0,0,0,.26,4.43l.54,2.33-25.08,4.93a1.05,1.05,0,0,0-.82.8l-2.36,6.34a3.85,3.85,0,0,0-.34.91v0h0c-.5,2.09-.13,5.59,1.13,5.59h26.87L539,409.54l-1.52,4.72H708.17C708.21,399,707.81,376,705.14,369.54ZM586.83,355.12,584.31,378c0,.29-.08.58-.13.86a10.06,10.06,0,0,1-10,7.86l-11.26,0a3.47,3.47,0,0,1-3.39-4.2l5.3-27.46a3.86,3.86,0,0,1,3.77-3.08H584a2.89,2.89,0,0,1,2.87,3.21Z",
    style: {
      fill: "#0C3450",
      transformOrigin: "610.049px 379.585px"
    },
    id: "el5fqvf42zn1y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.81,425.64l-72.65,1c-.47,0-1.31-1.4-1.31-1.87v-8.11a.86.86,0,0,1,.86-.86h73.1a.85.85,0,0,1,.85.86v8.11A.85.85,0,0,1,628.81,425.64Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "592.255px 421.22px"
    },
    id: "elcub3ez1ttkc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.83,355.12,584.31,378c0,.29-.08.57-.13.86a10,10,0,0,1-10,7.85H562.94a3.48,3.48,0,0,1-3.39-4.21l5.3-27.46a3.87,3.87,0,0,1,3.77-3.08H584a2.9,2.9,0,0,1,2.87,3.22Z",
    style: {
      fill: "#0C3450",
      transformOrigin: "573.18px 369.336px"
    },
    id: "elbgkybfol7we",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(&quot",
      transformOrigin: "622.842px 380.57px"
    },
    id: "eluw0s8jtg91k",
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M708.23,416.24a3.8,3.8,0,0,0-.23-1.83H537.69a3.91,3.91,0,0,0-.24,1.83Z",
    style: {
      fill: "#0C3450",
      mixBlendMode: "screen",
      transformOrigin: "622.842px 415.325px"
    },
    id: "eltz0e3g5rsb8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.85,347.56,540.6,379.41a15.24,15.24,0,0,0-.4,7.87l4.39,20.36h59.56v-58.9a3.84,3.84,0,0,0-3.84-3.84H554.5A3.85,3.85,0,0,0,550.85,347.56Z",
    style: {
      fill: "#0C3450",
      transformOrigin: "572.006px 376.27px"
    },
    id: "elypsono3jeyj",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M562.94,386.65a3.47,3.47,0,0,1-3.39-4.2l5.3-27.46a3.86,3.86,0,0,1,3.77-3.08H584a2.88,2.88,0,0,1,2.15,1,2.91,2.91,0,0,1,.72,2.25L584.31,378c0,.29-.08.58-.13.86a10.06,10.06,0,0,1-10,7.86Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "573.18px 369.316px"
    },
    id: "elo6oo7mfbxhn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.94,382.9a14.34,14.34,0,0,1,.68-3.3l8.9-27.64h5.09a4,4,0,0,1,3.06,1.41,3.78,3.78,0,0,1,.81,3.21l-4.91,23.24a4,4,0,0,1-3.86,3.08Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "549.25px 367.43px"
    },
    id: "elqf0gwikjg8j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.31,418.77H537.67c-1.3,0-1.3-4.72,0-4.72H708.31C709.62,414.05,709.62,418.77,708.31,418.77Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "622.994px 416.41px"
    },
    id: "elulbizl7673h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.3,365.74s0,.09,0,.26v.74c0,.69,0,1.64-.06,2.84-.08,2.51-.19,6.07-.32,10.45s-.34,9.68-.54,15.5c-.06,1.46-.11,3-.17,4.48a10.5,10.5,0,0,1-1,4.64,6.36,6.36,0,0,1-3.93,3,17.59,17.59,0,0,1-5,.6l-34.51-.65-10.45-.26-2.84-.1-.74,0a.79.79,0,0,1-.25,0,.67.67,0,0,1,.25,0h3.58l10.46.1,34.5.49a17,17,0,0,0,4.86-.56,5.85,5.85,0,0,0,3.63-2.7,10,10,0,0,0,1-4.42c.07-1.52.13-3,.19-4.48.24-5.82.46-11.07.65-15.49s.37-7.94.49-10.45c.06-1.2.12-2.15.15-2.84,0-.3,0-.54.06-.73A.7.7,0,0,1,604.3,365.74Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "574.4px 386.998px"
    },
    id: "elk57612d8by7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.67,407.88c-.15,0-.26-5-.26-11.17s.11-11.18.26-11.18.26,5,.26,11.18S555.81,407.88,555.67,407.88Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "555.67px 396.705px"
    },
    id: "elj3txdwhavi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.6,345.09a11.59,11.59,0,0,1-.19,1.61c-.15,1-.4,2.53-.73,4.37-.65,3.68-1.64,8.75-2.88,14.31s-2.52,10.58-3.5,14.18c-.49,1.81-.9,3.26-1.21,4.26a8.85,8.85,0,0,1-.52,1.54,11.11,11.11,0,0,1,.33-1.59c.27-1.1.62-2.55,1.05-4.3.88-3.63,2.09-8.64,3.34-14.2s2.29-10.61,3-14.27l.89-4.33A8.05,8.05,0,0,1,564.6,345.09Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "560.085px 365.225px"
    },
    id: "elvh52d05rnt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.35,395.74a3.23,3.23,0,0,0,.93-.38,1.78,1.78,0,0,0,.64-.93,2,2,0,0,0-.18-1.44,1.6,1.6,0,0,0-1.48-.78l-2.27,0-5.19,0a1.55,1.55,0,0,0-1.52,1.43,1.58,1.58,0,0,0,1,1.73,1.43,1.43,0,0,0,.5.09h1.67l2,0c1.21,0,2.19.05,2.86.08a3.85,3.85,0,0,1,1.05.1,3.85,3.85,0,0,1-1.05.1c-.67,0-1.65.06-2.86.08l-2,0H576.8a2.11,2.11,0,0,1-.66-.1,2.09,2.09,0,0,1-1.37-2.23,2,2,0,0,1,2-1.91l5.19,0,2.27,0a2,2,0,0,1,1.8,1,2.06,2.06,0,0,1,.24.91,2.2,2.2,0,0,1-.1.81,1.9,1.9,0,0,1-.81,1,1.58,1.58,0,0,1-.76.25C584.44,395.78,584.35,395.75,584.35,395.74Z",
    style: {
      fill: "#0C3450",
      transformOrigin: "580.514px 393.699px"
    },
    id: "elr0eemtrmu4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.09,371.2c0,.15-7,.26-15.58.26s-15.58-.11-15.58-.26,7-.26,15.58-.26S697.09,371.06,697.09,371.2Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "681.51px 371.2px"
    },
    id: "eljwxwhl0rqsk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.09,374.3c0,.15-7,.27-15.58.27s-15.58-.12-15.58-.27,7-.26,15.58-.26S697.09,374.16,697.09,374.3Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "681.51px 374.305px"
    },
    id: "elnul3zxu2u0j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.09,377.41c0,.14-7,.26-15.58.26s-15.58-.12-15.58-.26,7-.26,15.58-.26S697.09,377.26,697.09,377.41Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "681.51px 377.41px"
    },
    id: "el04lsyllawjqq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.09,380.51c0,.14-7,.26-15.58.26s-15.58-.12-15.58-.26,7-.26,15.58-.26S697.09,380.36,697.09,380.51Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "681.51px 380.51px"
    },
    id: "el2g04kx2hxob",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.09,383.61c0,.14-7,.26-15.58.26s-15.58-.12-15.58-.26,7-.26,15.58-.26S697.09,383.46,697.09,383.61Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "681.51px 383.61px"
    },
    id: "elvlm8h5j2dc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.09,386.71c0,.14-7,.26-15.58.26s-15.58-.12-15.58-.26,7-.26,15.58-.26S697.09,386.56,697.09,386.71Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "681.51px 386.71px"
    },
    id: "el0hl6hyofy2ps",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.09,389.81c0,.14-7,.26-15.58.26s-15.58-.12-15.58-.26,7-.26,15.58-.26S697.09,389.66,697.09,389.81Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "681.51px 389.81px"
    },
    id: "elp2sqiced8ws",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.2,463.46c-9.35,0-17.22-9-17.22-18.38s8.23-17.24,17.58-17.24L671.19,421a20.24,20.24,0,0,1,18.89,10.54,20,20,0,0,1,1.68,13.95c-4,18.2-19.11,18-25,17.59S520.2,463.46,520.2,463.46Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "597.654px 442.215px"
    },
    id: "elg6sznkkc8es",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 520.2,
    cy: 444.97,
    r: 14.07,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "520.2px 444.97px"
    },
    id: "elipq093dhjnj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 670.24,
    cy: 442.11,
    r: 18.2,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "670.24px 442.11px"
    },
    id: "ely0qzggt30s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.27,424.49l-.39.06-1.15.13-4.42.44c-3.85.38-9.41.88-16.3,1.44-13.76,1.13-32.8,2.44-53.85,3.37s-40.15,1.3-54,1.38c-6.91,0-12.49,0-16.36,0l-4.44-.06-1.16,0a1.65,1.65,0,0,1-.39,0l.39,0,1.16,0,4.44,0,16.36-.16c13.8-.18,32.88-.61,53.93-1.53s40.09-2.18,53.85-3.22l16.31-1.27,4.43-.35,1.16-.07A1.64,1.64,0,0,1,672.27,424.49Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "596.04px 427.9px"
    },
    id: "el7lu44kgvcr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.48,458.59c0,.14-32.75.26-73.15.26s-73.15-.12-73.15-.26,32.74-.26,73.15-.26S666.48,458.44,666.48,458.59Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "593.33px 458.59px"
    },
    id: "elfz531jf46a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.29,407.39a34.08,34.08,0,0,1-1-3.54c-.61-2.19-1.5-5.21-2.4-8.58a69.84,69.84,0,0,1-1.88-8.72,20,20,0,0,1-.16-2.71,3.33,3.33,0,0,1,.13-1c.08,0,0,1.41.39,3.64s1.12,5.3,2,8.65,1.74,6.39,2.26,8.62c.26,1.11.46,2,.56,2.64A3.47,3.47,0,0,1,545.29,407.39Z",
    style: {
      fill: "#0C3450",
      transformOrigin: "542.571px 395.115px"
    },
    id: "elvji24jdsitn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.22,453.35a4.77,4.77,0,0,1-1.05-.69,12.62,12.62,0,0,1-2.34-2.47,14.09,14.09,0,0,1-2.19-4.57,13.22,13.22,0,0,1,2.3-11.84,14.23,14.23,0,0,1,3.74-3.41,12.68,12.68,0,0,1,3.11-1.41,4.86,4.86,0,0,1,1.22-.25,20.4,20.4,0,0,0-4.13,2,14.72,14.72,0,0,0-3.56,3.39,13.09,13.09,0,0,0-2.22,11.43,14.15,14.15,0,0,0,2,4.47A19.45,19.45,0,0,0,660.22,453.35Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "659.564px 441.03px"
    },
    id: "elrd2o6c3e4yl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.16,367.84a97.53,97.53,0,0,1-7.82,6,91.53,91.53,0,0,1-8.12,5.55,97.53,97.53,0,0,1,7.82-6A91.53,91.53,0,0,1,581.16,367.84Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "573.19px 373.615px"
    },
    id: "el4aqr8mns4zn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.36,363.59a70.37,70.37,0,0,1-6.81,5.08,69.22,69.22,0,0,1-7.11,4.65,72.37,72.37,0,0,1,6.81-5.08A70,70,0,0,1,582.36,363.59Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "575.4px 368.455px"
    },
    id: "el5vys11gd2sr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553,370.15a18,18,0,0,1-3.45,2.72,18.85,18.85,0,0,1-3.76,2.3,19.25,19.25,0,0,1,3.46-2.72A18.63,18.63,0,0,1,553,370.15Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "549.395px 372.66px"
    },
    id: "elung64ntjevd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.05,366.17a52.65,52.65,0,0,1-8.21,6.37,51.43,51.43,0,0,1,8.21-6.37Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "550.945px 369.355px"
    },
    id: "elnc3a1vh852j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.45,390.5a60.22,60.22,0,0,1-11.18,0,60.22,60.22,0,0,1,11.18,0Z",
    style: {
      fill: "#0C3450",
      transformOrigin: "580.86px 390.5px"
    },
    id: "elntlcqgivy3o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.4,456.91a4.26,4.26,0,0,1-1.22-.26,11.66,11.66,0,0,1-3.08-1.51,13.28,13.28,0,0,1-3.55-3.64,12,12,0,0,1-.85-12,13.06,13.06,0,0,1,3-4.1,11.46,11.46,0,0,1,2.84-1.93,5,5,0,0,1,1.17-.43,17.66,17.66,0,0,0-3.75,2.63,13.25,13.25,0,0,0-2.83,4,11.79,11.79,0,0,0,.81,11.55,13.23,13.23,0,0,0,3.37,3.6A17.36,17.36,0,0,0,517.4,456.91Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "512.441px 444.975px"
    },
    id: "elgssnqsr622",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.74,401.4c0,.14-5.42.26-12.11.26s-12.12-.12-12.12-.26,5.42-.26,12.12-.26S538.74,401.26,538.74,401.4Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "526.625px 401.4px"
    },
    id: "el0v92nfmb25jl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.52,105.1,420.4,85.51a12.1,12.1,0,0,0-16.08-5.86h0a12.1,12.1,0,0,0-5.86,16.08l9.13,19.58a.73.73,0,0,0,1,.36l20.6-9.6A.73.73,0,0,0,429.52,105.1Z",
    style: {
      fill: "#0C3450",
      transformOrigin: "413.46px 97.1334px"
    },
    id: "elczcudthea1w",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Fence--inject-139",
    className: "animable",
    style: {
      transformOrigin: "125.91px 411.625px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.76,
    y: 368.59,
    width: 5.14,
    height: 94.49,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "77.33px 415.835px"
    },
    id: "eleh2mwxntn9a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.53,365.35a5.18,5.18,0,1,1-5.18-5.18A5.18,5.18,0,0,1,82.53,365.35Z",
    style: {
      fill: "#0C3450",
      transformOrigin: "77.35px 365.35px"
    },
    id: "elubtrxu52ze",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.9,
    y: 368.59,
    width: 5.14,
    height: 94.49,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "179.47px 415.835px"
    },
    id: "elvsjthjagyub",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.67,365.35a5.18,5.18,0,1,1-5.18-5.18A5.18,5.18,0,0,1,184.67,365.35Z",
    style: {
      fill: "#0C3450",
      transformOrigin: "179.49px 365.35px"
    },
    id: "elahh59m8zmd9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.09,
    y: 377.71,
    width: 131.69,
    height: 23.56,
    style: {
      fill: "#0C3450",
      transformOrigin: "125.935px 389.49px"
    },
    id: "el67qyd36m3q3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.99 377.7 74.76 378.1 61.23 401.27 60.09 401.27 60.09 377.7 74.99 377.7",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "67.54px 389.485px"
    },
    id: "elqjqo7cpgnhr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.28 377.7 94.5 401.27 76.51 401.27 81.98 391.91 90.28 377.7 108.28 377.7",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "92.395px 389.485px"
    },
    id: "elxwyxlq4xyi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.55 377.7 127.78 401.27 109.78 401.27 123.55 377.7 141.55 377.7",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "125.665px 389.485px"
    },
    id: "elmrfjdctng7h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.81 377.71 161.04 401.27 143.05 401.27 156.82 377.71 174.81 377.71",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "158.93px 389.49px"
    },
    id: "elaca1sh10sqc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.78 377.71 191.78 401.27 176.32 401.27 190.1 377.71 191.78 377.71",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "184.05px 389.49px"
    },
    id: "elsyi5orb1wpn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.09,
    y: 414.1,
    width: 131.69,
    height: 23.56,
    style: {
      fill: "#0C3450",
      transformOrigin: "125.935px 425.88px"
    },
    id: "elyjy5lqzv8q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.99 414.11 74.76 414.5 61.23 437.67 60.09 437.67 60.09 414.11 74.99 414.11",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "67.54px 425.89px"
    },
    id: "elyt5iqcx1woq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.28 414.11 94.5 437.67 76.51 437.67 81.98 428.31 90.28 414.11 108.28 414.11",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "92.395px 425.89px"
    },
    id: "elhnv5rg5gc1m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.55 414.11 127.78 437.67 109.78 437.67 123.55 414.11 141.55 414.11",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "125.665px 425.89px"
    },
    id: "ellvslr6zy25",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.81 414.11 161.04 437.67 143.05 437.67 156.82 414.11 174.81 414.11",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "158.93px 425.89px"
    },
    id: "eln4p7mt8dun",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.78 414.11 191.78 437.67 176.32 437.67 190.1 414.11 191.78 414.11",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "184.05px 425.89px"
    },
    id: "el6bkpgul0zwn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.78,401.27s0-.14,0-.41,0-.67,0-1.18c0-1.05,0-2.58,0-4.58,0-4-.05-9.88-.08-17.39l.14.13L60.1,378h0l.26-.26v23.56l-.26-.26,93.75.11,27.8.08,7.51,0,1.95,0,.68,0h-.65l-1.92,0-7.45,0-27.74.07-93.93.11h-.26V377.44h.27l131.68.13h.13v.14c0,7.54-.06,13.44-.07,17.47,0,2,0,3.51,0,4.55,0,.5,0,.88,0,1.16S191.78,401.27,191.78,401.27Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "125.88px 389.425px"
    },
    id: "el5naq3b0xb2d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.78,437.67s0-.15,0-.41,0-.67,0-1.18c0-1.05,0-2.58,0-4.58,0-4-.05-9.88-.08-17.4l.14.14-131.68.12h0l.26-.26v23.57l-.26-.26,93.75.11,27.8.08,7.51,0,1.95,0c.44,0,.68,0,.68,0h-.65l-1.92,0-7.45,0-27.74.08-93.93.11h-.26V413.84h.27l131.68.13h.13v.13c0,7.55-.06,13.45-.07,17.48,0,2,0,3.51,0,4.55,0,.5,0,.88,0,1.16S191.78,437.67,191.78,437.67Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "125.94px 425.815px"
    },
    id: "el0dnlys4sf44",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-139",
    className: "animable animator-hidden",
    style: {
      transformOrigin: "377px 463.46px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M701.78,463.46c0,.14-145.42.26-324.76.26s-324.8-.12-324.8-.26,145.39-.26,324.8-.26S701.78,463.31,701.78,463.46Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "377px 463.46px"
    },
    id: "elp0705t0sv7",
    className: "animable"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-139"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M586.83,355.12,584.31,378c0,.29-.08.57-.13.86a10,10,0,0,1-10,7.85H562.94a3.48,3.48,0,0,1-3.39-4.21l5.3-27.46a3.87,3.87,0,0,1,3.77-3.08H584a2.9,2.9,0,0,1,2.87,3.22Z",
    style: {
      fill: "#FF725E"
    }
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderMaintenance);
export default __webpack_public_path__ + "static/media/underMaintenance.a2aa61f29924267cbc373a43ad5ed7de.svg";
export { ForwardRef as ReactComponent };